import * as challengeLevels from './challengeLevels';
import * as colliderCallbacks from './colliderCallbacks';
import * as utility from './utility';
import * as userAccounts from './userAccounts';
let $ = require( 'jquery' );

export var QueenBees = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function QueenBees (scene, x, y, username, colonyName, species, isBot)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.colonyName = colonyName;
        this.species = species;
        this.isBot = isBot;

        if (!this.species)
        {
            this.species = 'mellifera';
        }

        switch(this.species)
        {
            case 'mellifera':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');
                break;
            case 'melliferaCat':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinCat.png');
                break;
            case 'melliferaBlue':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinBlue.png');
                break;
            case 'melliferaViolet':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinViolet.png');
                break;
            case 'melliferaCrown':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBeeCrownSkin.png');
                break;
            case 'bumble':
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeQueen.png');
                // this.queenBeeShadowSpine = scene.add.spine(400, 600, 'worker', 'flying', true);
                break;
            default:
                this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');
                // this.queenBeeShadowSpine = scene.add.spine(400, 600, 'worker', 'flying', true);
                break;
        }

        // this.queenBeeShadowSpine.setScale(.25, .25);
        // this.queenBeeShadowSpine.setAlpha(.25);
        this.queenBeeShadowSprite.tint = 0x3c2040;
        this.queenBeeShadowSprite.alpha = .1;

        this.enableSpine = this.scene.enableSpine;
        // this.enableSpine = false;

        switch(this.species)
        {
            case 'mellifera':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');
                break;
            case 'melliferaCat':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinCat.png');
                break;
            case 'melliferaBlue':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinBlue.png');
                break;
            case 'melliferaViolet':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenHoneyBeeSkinViolet.png');
                break;
            case 'melliferaCrown':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBeeCrownSkin.png');
                this.queenBeeGlowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBeeCrownGlow.png');
                scene.queenBeeGlowsGroup.add(this.queenBeeGlowSprite);
                break;
            case 'bumble':
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeQueen.png');
                break;
            default:
                this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');
                break;
        }

        scene.queenBeesGroup.add(this.queenBeeSprite);
        this.queenBeeSprite.body.stopVelocityOnCollide = false;
        this.queenBeeSprite.body.collideWorldBounds = true;
        this.queenBeeSprite.setSize(100, 100);
        this.queenBeeSprite.body.setBounce(1, 1);
        // this.queenBeeSprite.body.setMass(50);
        this.queenBeeSprite.username = username;
        this.queenBeeSprite.colonyName = colonyName;
        this.queenBeeSprite.species = species;
        this.queenBeeSprite.isBot = this.isBot;
        this.queenBeeSprite.parent = this;

        if (this.enableSpine)
        {
            this.queenBeeSprite.enableSpine = this.enableSpine;
            this.queenBeeSprite.setAlpha(.0001);
            // Create Spine object
            this.queenBeeSpine = scene.add.spine(400, 600, 'worker', 'idle', true);
            this.queenBeeSpine.setDepth(10);
            this.scale = .35;

            let selectedSkin;
            if (this.species == 'mellifera')
            {
                selectedSkin = this.queenBeeSpine.skeletonData.skins.find(skin => skin.name == 'melliferaQueen');
            } else {
                selectedSkin = this.queenBeeSpine.skeletonData.skins.find(skin => skin.name == species);
            }
            this.queenBeeSpine.setSkin(selectedSkin);

            var scaleInTween = scene.tweens.add({
                targets: this.queenBeeSpine,
                scaleX: this.scale,
                scaleY: this.scale,
                duration: 500,
                ease: 'Bounce',
            });

            // scene.queenBeesGroup.add(this.queenBeeSpine);
        }

        // What is this bee carrying?
        this.queenBeeSprite.pollenCarriedGroup = scene.physics.add.group();
        this.queenBeeSprite.pollenCarriedGroup.setDepth(50);
        this.queenBeeSprite.carryingBeeBread = false;
        this.queenBeeSprite.beeBreadCarriedGroup = scene.physics.add.group();
        this.queenBeeSprite.beeBreadCarriedGroup.setDepth(50);
        scene.physics.add.overlap(this.queenBeeSprite.beeBreadCarriedGroup, scene.broodsGroup, colliderCallbacks.beeBreadTouchedBrood);

        this.queenBeeSprite.targetRecentlyChanged = false;

        this.queenBeeSprite.isWorker = false;
        this.queenBeeSprite.role = 'nurse';

        // Pheromones
        this.followPheromoneActive = false;
        this.alarmPheromoneActive = false;

        this.inputGiven = false;

        // Create alarm pheromone particle emitter.
        this.alarmPheromoneParticles = scene.add.particles(0,0, 'sprites', {
            frame: 'alarm.png',
            speed: 100,
            gravity: {x: 0, y: 0},
            scale: {start: 0.1, end: 1},
            lifespan: 1000,
            frequency: 250,
            follow: this.queenBeeSprite
        });
        this.alarmPheromoneParticles.emitting = false;
        
        this.queenBeeSprite.hitPoints = 100;
        // Create health bar
        var rect = new Phaser.Geom.Rectangle(0, 0, this.queenBeeSprite.hitPoints, 15);
        this.queenBeeSprite.healthBar = scene.add.graphics({ fillStyle: { color: 0xf2dd89 } });
        this.queenBeeSprite.healthBar.fillRectShape(rect);
        scene.uiGroup.add(this.queenBeeSprite.healthBar);
        this.queenBeeSprite.healthBar.alpha = .5;

        // Make it wiggle.
        let wiggleAmount;
        switch(species)
        {
            case 'mellifera':
                wiggleAmount = .04;
                break;
            case 'bumble':
                wiggleAmount = .075;
                break;
            default:
                wiggleAmount = .01;
                break;
        }
        this.wiggle = scene.tweens.addCounter({
            from: -wiggleAmount,
            to: wiggleAmount,
            duration: 200,
            yoyo: true,
            repeat: -1,
            ease: 'Cubic.easeInOut'
        });

        // Bot variables
        if (this.isBot)
        {
            this.recentlyLaidEgg = false;
            this.recentlyPlacedNewHive = false;
            scene.queenBeeBotsGroup.add(this.queenBeeSprite);
            this.dangerZone = 750;

            let that = this;
            setTimeout(function()
            {
                that.queenBeeSprite.target = utility.closestEmptyCell(scene, that.queenBeeSprite);
                that.queenBeeSprite.task = 'headingToNearestCell';
            }, 10);

        }

    },

    setLayEggAnimation(queenBee, selectedCell)
    {
    	try {
    		// Move queen into cell first.
    		let angleBetweenQueenAndCell = Phaser.Math.Angle.BetweenPoints(queenBee, selectedCell) * 180;
    		if (angleBetweenQueenAndCell > 90)
    		{
    			angleBetweenQueenAndCell = 90;
    		} else if (angleBetweenQueenAndCell < -90)
    		{
    			angleBetweenQueenAndCell = -90;
    		}
    		var queenMovesIntoSelectedCell = queenBee.scene.tweens.add({
    			targets: queenBee,
    			x: selectedCell.x,
    			y: selectedCell.y,
    			angle: angleBetweenQueenAndCell,
    			duration: 1000,
    			ease: 'Sine',
    			onComplete: function() {
    				try {
    					if (queenBee.parent.queenBeeSpine &&
    						queenBee.parent.queenBeeSpine.state.tracks[0].animation.name != 'layEgg')
    					{
    						let currentAnimation = queenBee.parent.queenBeeSpine.state.tracks[0].animation.name;
    						queenBee.parent.queenBeeSpine.setAnimation(0, 'layEgg', false);
    						queenBee.parent.queenBeeSpine.addAnimation(0, currentAnimation, true, 0);
    					}
    				} catch(e) {
    					console.log('There was an error after queen completing moving into a cell: ', e);
    				}
    			}
    		});
    	} catch (e) {
    		console.log('Error occurred when setting layEgg animation on queen bee: ', error);
    	}
    },

    update: function (queenBee)
    {
        try {
            if (queenBee.queenBeeSprite.body)
            {

                let speed;
                switch(queenBee.scene.selectedSpecies)
                {
                    case 'mellifera':
                        speed = queenBee.scene.melliferaQueenSpeed;
                        break;
                    case 'bumble':
                        speed = queenBee.scene.bumbleQueenSpeed;
                        break;
                    default:
                        speed = queenBee.scene.melliferaQueenSpeed;
                        break;
                }
                let acceleration = speed * 3;


                // Only do these things if this queen is the player.
                if (queenBee.username == queenBee.scene.username)
                {

                    if (queenBee.scene.virtualJoystickEnabled != 'true')
                    {
                        // No virtual joystick.

                        // Deal with pointers (mouse and touch).
                        if (queenBee.queenBeeSprite &&
                            this.scene.input.manager.activePointer.isDown == true &&
                            queenBee.scene.uiActive == false)
                        {
                            // console.log('Pointer down');
                            queenBee.queenBeeSprite._rotation = queenBee.wiggle.getValue() + this.scene.physics.moveTo(
                                queenBee.queenBeeSprite,
                                this.scene.input.manager.activePointer.position.x + this.scene.cameras.main.scrollX,
                                this.scene.input.manager.activePointer.position.y + this.scene.cameras.main.scrollY,
                                speed
                            );
                        }

                    } else {
                        // Using virtual joystick for movement.

                          if (queenBee.scene.virtualJoyStick.cursorKeys.up.isDown ||
                              queenBee.scene.virtualJoyStick.cursorKeys.down.isDown ||
                              queenBee.scene.virtualJoyStick.cursorKeys.left.isDown ||
                              queenBee.scene.virtualJoyStick.cursorKeys.right.isDown)
                        {
                            // console.log('Virtual joystick cursor keys:', queenBee.scene.virtualJoyStick.force);
                            let speed = queenBee.scene.virtualJoyStick.force * 2;
                            if (speed > 300)
                            {
                                speed = 300;
                            }
                            queenBee.scene.physics.velocityFromAngle(
                                queenBee.scene.virtualJoyStick.angle,
                                speed,
                                queenBee.queenBeeSprite.body.velocity
                            );
                            queenBee.queenBeeSprite.setAngle(queenBee.scene.virtualJoyStick.angle);
                            queenBee.queenBeeSprite.angle += queenBee.wiggle.getValue()*5;
                        } else
                        {
                            try
                            {
                                queenBee.queenBeeSprite.setVelocityX(0);
                                queenBee.queenBeeSprite.setVelocityY(0);
                            } catch (err)
                            {
                                console.log('Error updating queen bee: ', err);
                            }
                        }

                    }

                    // Deal with keyboard.
                    // Deal with forward and backward.
                      if (queenBee.scene.cursors.up.isDown || queenBee.scene.wKey.isDown)
                    {
                        console.log('cursor up');
                        queenBee.scene.physics.velocityFromAngle(queenBee.queenBeeSprite.angle, speed, queenBee.queenBeeSprite.body.velocity);
                        queenBee.queenBeeSprite.angle += queenBee.wiggle.getValue()*5;
                    }
                    else if (queenBee.scene.cursors.down.isDown || queenBee.scene.sKey.isDown)
                    {
                        queenBee.scene.physics.velocityFromAngle(queenBee.queenBeeSprite.angle, -speed, queenBee.queenBeeSprite.body.velocity);
                        queenBee.queenBeeSprite.angle += queenBee.wiggle.getValue()*5;
                    } else if (this.scene.input.manager.activePointer.isDown == false)
                    {
                        try
                        {
                            queenBee.queenBeeSprite.setVelocityX(0);
                            queenBee.queenBeeSprite.setVelocityY(0);
                        } catch (err)
                        {
                            console.log('Error: ', err);
                        }
                    }

                    // Deal with left and right turning.
                    if (queenBee.scene.cursors.left.isDown || queenBee.scene.aKey.isDown)
                    {
                        queenBee.queenBeeSprite.setAngularVelocity(-100);
                    }
                    else if (queenBee.scene.cursors.right.isDown || queenBee.scene.dKey.isDown)
                    {
                        queenBee.queenBeeSprite.setAngularVelocity(100);
                    } else {
                        queenBee.queenBeeSprite.setAngularVelocity(0);
                    }

                }

                // Bot Behavior
                if (queenBee.isBot)
                {
                    // Respond to threats.
                    queenBee.botDetermineWaspThreat(queenBee);

                    // Behave differently depending on task.
                    switch(queenBee.queenBeeSprite.task)
                    {
                        case 'headingToNearestCell':
                            if (queenBee.queenBeeSprite.target != null)
                            {
                                queenBee.queenBeeSprite._rotation = queenBee.wiggle.getValue() + this.scene.physics.accelerateToObject(
                                    queenBee.queenBeeSprite,
                                    queenBee.queenBeeSprite.target,
                                    acceleration,
                                    speed,
                                    speed
                                );
                            } else {
                                queenBee.queenBeeSprite.target = utility.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                                if (!queenBee.queenBeeSprite.target) queenBee.queenBeeSprite.task = 'headingToNewHiveLocation'; // Create a new hive if none exist
                            }
                            break;
                        case 'layingEggs':
                            if (!queenBee.queenBeeSprite.target ||
                                queenBee.queenBeeSprite.target == null)
                            {
                                queenBee.queenBeeSprite.target = utility.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                                if (queenBee.queenBeeSprite.target == null)
                                {
                                    queenBee.queenBeeSprite.task = 'headingToNewHiveLocation';
                                    // console.log('headingToNewHiveLocation');
                                }
                            } else {
                                queenBee.queenBeeSprite._rotation = queenBee.wiggle.getValue() + this.scene.physics.accelerateToObject(
                                    queenBee.queenBeeSprite,
                                    queenBee.queenBeeSprite.target,
                                    10,
                                    10,
                                    10
                                );
                            }

                            if (!queenBee.recentlyLaidEgg)
                            {
                                queenBee.botLayEgg(queenBee);
                                queenBee.queenBeeSprite.target = utility.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                                if (queenBee.queenBeeSprite.target != null)
                                {
                                    let distanceToClosestEmptyCell = Phaser.Math.Distance.Between(
                                        queenBee.queenBeeSprite.x,
                                        queenBee.queenBeeSprite.y,
                                        queenBee.queenBeeSprite.target.x,
                                        queenBee.queenBeeSprite.target.y
                                    );
                                    if (distanceToClosestEmptyCell < 20)
                                    {
                                        queenBee.queenBeeSprite.task = 'headingToNearestCell';
                                    } else {
                                        queenBee.queenBeeSprite.task = 'headingToNewHiveLocation';
                                        // console.log('headingToNewHiveLocation');
                                    }
                                } else {
                                    // console.log('No empty cells available.');
                                }
                            }
                            break;
                        case 'headingToNewHiveLocation':
                            if (!queenBee.queenBeeSprite.newHiveDestinationX ||
                                !queenBee.queenBeeSprite.newHiveDestinationY)
                            {
                                queenBee.queenBeeSprite.newHiveDestinationX = Phaser.Math.RND.integerInRange(-1100,1100);
                                queenBee.queenBeeSprite.newHiveDestinationY = Phaser.Math.RND.integerInRange(-1100,1100);
                            }
                            queenBee.queenBeeSprite._rotation = queenBee.wiggle.getValue() + this.scene.physics.accelerateTo(
                                queenBee.queenBeeSprite,
                                queenBee.queenBeeSprite.newHiveDestinationX,
                                queenBee.queenBeeSprite.newHiveDestinationY,
                                speed,
                                speed,
                                speed
                            );
                            let distanceToNewHiveDestination = Phaser.Math.Distance.Between(
                                queenBee.queenBeeSprite.x,
                                queenBee.queenBeeSprite.y,
                                queenBee.queenBeeSprite.newHiveDestinationX,
                                queenBee.queenBeeSprite.newHiveDestinationY
                            );
                            if (distanceToNewHiveDestination < 200 && !queenBee.recentlyPlacedNewHive)
                            {
                                queenBee.botNewHive(queenBee);
                            }
                            break;
                        default:
                            // console.log('Queenbee bot has no task. Heading to nearest cell.');
                            queenBee.queenBeeSprite.task = 'headingToNearestCell';
                            break;
                    }

                }

                // Adjust position of spine shadow object
                // this.queenBeeShadowSpine.setX(queenBee.queenBeeSprite.x + 10);
                // this.queenBeeShadowSpine.setY(queenBee.queenBeeSprite.y + 10);
                // this.queenBeeShadowSpine.setAngle(queenBee.queenBeeSprite.angle);
                // this.queenBeeShadowSpine.setAlpha(.1);

                if (queenBee.enableSpine &&
                    queenBee.queenBeeSpine )
                {
                    // Adjust position of spine object
                    this.queenBeeSpine.setX(queenBee.queenBeeSprite.x);
                    this.queenBeeSpine.setY(queenBee.queenBeeSprite.y);
                    this.queenBeeSpine.setAngle(queenBee.queenBeeSprite.angle);

                    if (queenBee.queenBeeSpine.state.tracks[0].animation.name != 'attack' &&
                        queenBee.queenBeeSpine.state.tracks[0].animation.name != 'layEgg')
                    {
                        if (queenBee.queenBeeSpine.state &&
                            queenBee.queenBeeSprite.body &&
                            queenBee.queenBeeSprite.body.speed >= 90)
                        {
                            if (queenBee.queenBeeSpine.state.tracks[0].animation.name != 'attack' &&
                                queenBee.queenBeeSpine.state.tracks[0].animation.name != 'flying')
                            {
                                // console.log('Worker now flying.');
                                queenBee.queenBeeSpine.setAnimation(0, 'flying', true, 0);
                            }
                        } else if (queenBee.queenBeeSprite.body &&
                                   queenBee.queenBeeSpine.state.tracks[0].animation.name != 'attack' &&
                                   queenBee.queenBeeSprite.body.speed >= 10)
                        {
                            if (queenBee.queenBeeSpine.state.tracks[0].animation.name != 'walking')
                            {
                                // console.log('Worker now walking.');
                                queenBee.queenBeeSpine.setAnimation(0, 'walking', true, 0);
                            }
                        } else
                        {
                            if (queenBee.queenBeeSpine.state &&
                                queenBee.queenBeeSpine.state.tracks[0].animation.name != 'attack' &&
                                queenBee.queenBeeSpine.state.tracks[0].animation.name != 'idle')
                            {
                                // console.log('Worker now idle.');
                                queenBee.queenBeeSpine.setAnimation(0, 'idle', true, 0);
                            }
                        }
                    } else {
                        // console.log('Queen bee animation is 'attack'.');
                    }
                }

                // Adjust position of shadow sprite.
                var offset = 10;
                var queenBeeShadowSpriteNewLocationTween = queenBee.scene.tweens.add({
                    targets: queenBee.queenBeeShadowSprite,
                    x: queenBee.queenBeeSprite.x + offset,
                    y: queenBee.queenBeeSprite.y + offset,
                    angle: queenBee.queenBeeSprite.angle,
                    duration: queenBee.scene.objectUpdateRate,
                    ease: 'Linear',
                });

                // Adjust position of healthBar.
                queenBee.queenBeeSprite.healthBar.setX(queenBee.queenBeeSprite.x -(queenBee.queenBeeSprite.width/2));
                queenBee.queenBeeSprite.healthBar.setY(queenBee.queenBeeSprite.y - 75);

                if (queenBee.queenBeeGlowSprite)
                {
                    // Adjust position of glow sprite.
                    var queenBeeGlowSpriteNewLocationTween = queenBee.scene.tweens.add({
                        targets: queenBee.queenBeeGlowSprite,
                        x: queenBee.queenBeeSprite.x,
                        y: queenBee.queenBeeSprite.y,
                        duration: queenBee.scene.objectUpdateRate,
                        ease: 'Linear',
                    });
                }

                // Update the position of all the pollen carried by the bee.
                var childrenPollens = queenBee.queenBeeSprite.pollenCarriedGroup.getChildren();
                for (var i = 0; i < childrenPollens.length; i++)
                {
                    var childrenPollensNewLocationTween = queenBee.scene.tweens.add({
                        targets: childrenPollens[i],
                        x: queenBee.queenBeeSprite.x + childrenPollens[i].offsetWhenCarriedX,
                        y: queenBee.queenBeeSprite.y + childrenPollens[i].offsetWhenCarriedY,
                        duration: queenBee.scene.objectUpdateRate,
                        ease: 'Linear',
                    });
                }

                // Update the position of all the beeBread carried by the bee.
                var childrenBeeBreads = queenBee.queenBeeSprite.beeBreadCarriedGroup.getChildren();
                for (var i = 0; i < childrenBeeBreads.length; i++)
                {
                    var childrenBeeBreadsNewLocationTween = queenBee.scene.tweens.add({
                        targets: childrenBeeBreads[i],
                        x: queenBee.queenBeeSprite.x,
                        y: queenBee.queenBeeSprite.y,
                        angle: queenBee.queenBeeSprite.angle,
                        duration: queenBee.scene.objectUpdateRate,
                        ease: 'Linear',
                    });
                }

            }

        } catch(err) {
            console.log('Error updating queenBee: ', err);
        }

    },

    setAttackAnimation: function (queenBee)
    {
    	try {
    		if (queenBee.parent.queenBeeSpine &&
                queenBee.parent.queenBeeSpine.state &&
    			queenBee.parent.queenBeeSpine.state.tracks[0].animation.name != 'attack')
    		{
    			let currentAnimation = queenBee.parent.queenBeeSpine.state.tracks[0].animation.name;
    			// console.log('Setting attack animation. Current animation:', currentAnimation);
    			queenBee.parent.queenBeeSpine.setAnimation(0, 'attack', false);
    			queenBee.parent.queenBeeSpine.addAnimation(0, currentAnimation, true, 0);
    		}
    	} catch (e) {
    		console.log('Error occurred when setting attack animation on queen bee: ', e);
    	}
    },

    healthChange: function (queenBee, hurtOrHeal, amount)
    {

        try {
            // Get reference to queen.
            let target;
            if (queenBee.queenBeeSprite)
            {
                target = queenBee.queenBeeSprite;
            } else {
                target = queenBee;
            }

            // Adjust hit point total.
            if (hurtOrHeal == 'hurt')
            {
                  target.hitPoints -= amount;
            } else if (hurtOrHeal == 'heal') {
                target.hitPoints += amount;
            }
            // Don't go above 100 or below 0 hit points.
            if (target.hitPoints > 100)
            {
                target.hitPoints = 100;
            } else if (target.hitPoints < 0) {
                target.hitPoints = 0;
            }
            // console.log('New total queenBee hitpoints: ', queenBee.hitPoints);

            // Health Bar
            if (target.healthBar)
            {
                let healthBarXScale = target.hitPoints / 100;
                target.healthBar.setScale(healthBarXScale, 1);
                // var queenBeeHealthChangeTween = target.scene.tweens.add({
                //     targets: target.healthBar,
                //     width: target.hitPoints,
                //     duration: 250,
                //     ease: 'Sine'
                // });
            }

            // Queen dies on 0 or fewer hit-points.
            if (queenBee.hitPoints <= 0)
            {
                // console.log('A queen should be dead, with ', queenBee.hitPoints, ' hit points.');
                queenBee.parent.dies(queenBee);
            }
        } catch (e) {
            console.log('Error occured trying to set queen bee healthBar: ', e);
            console.log('queenBee was: ', queenBee);
        }
    },

    dies: function (queenBee)
    {
        // Place a corpse sprite.
        let queenBeeCorpse;
        switch(queenBee.species)
        {
            case 'mellifera':
                queenBeeCorpse = queenBee.scene.physics.add.sprite(queenBee.x, queenBee.y, 'sprites', 'deadWorker.png');
            break;
            case 'bumble':
                queenBeeCorpse = queenBee.scene.physics.add.sprite(queenBee.x, queenBee.y, 'sprites', 'deadBumbleBeeWorker.png');
                break;
            default:
                queenBeeCorpse = queenBee.scene.physics.add.sprite(queenBee.x, queenBee.y, 'sprites', 'deadWorker.png');
                break;
        }
        queenBeeCorpse.angle = Phaser.Math.RND.integerInRange(0,359);
        queenBee.scene.tweens.add({
            targets: queenBeeCorpse,
            alpha: 0,
            duration: queenBee.scene.corpseFadeTime,
            ease: 'Sine'
        });

        // Game over if player died.
        if (queenBee == queenBee.scene.queenBees[0].queenBeeSprite) {
            // Player died.
            console.log('Player died for some reason.');
            queenBee.parent.gameOverByDeadQueen(queenBee.scene);
        } else {
            console.log('Rival queen died.');
        }

        // Remove queen bee from scene.
        if (queenBee.parent.queenBeeSpine)
        {
            queenBee.parent.queenBeeSpine.destroy();
        }
        let scene = queenBee.scene;
        queenBee.scene.queenBeesGroup.remove(queenBee);
        queenBee.parent.alarmPheromoneParticles.emitting = false;
        queenBee.parent.queenBeeShadowSprite.destroy();
        queenBee.parent.active = false;
        queenBee.destroy();

        challengeLevels.tallyNumberOfQueenBeesScores(scene);
    },

    gameOverByDeadQueen: function (scene)
    {
        try {
            console.log('Queen bee died.');
            scene.challengeConcluded = true;
            scene.challengeFail = true;
            document.getElementById('winLossText').innerHTML = 'Your queen bee died.';
            document.getElementById('honeyEarnedText').innerHTML = '';
            document.getElementById('continuePlayingButton').hidden = true;
            document.getElementById('winLossOr').hidden = true;
            document.getElementById('continuePlayingRow').hidden = true;
            document.getElementById('nextLevelButton').innerHTML = '<i class="fa fa-redo fa-1x"></i><br>Try Again';
            $('#winLossModal').modal({backdrop: 'static'});
        } catch (e) {
            console.log('There was an error on loss by dead queen.', e);
        }
    },

    botLayEgg: function (queenBee)
    {
        let closestCellToBot = utility.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
        console.log('Bot lay egg...');
        if (closestCellToBot &&
            closestCellToBot.typeOfCell == 'empty')
        {
            let distanceToClosestEmptyCell = Phaser.Math.Distance.Between(
                queenBee.queenBeeSprite.x,
                queenBee.queenBeeSprite.y,
                closestCellToBot.x,
                closestCellToBot.y
            );
            if (distanceToClosestEmptyCell < 250)
            {
                queenBee.setLayEggAnimation(queenBee.queenBeeSprite, closestCellToBot);
                closestCellToBot.typeOfCell = 'brood';
                queenBee.scene.broods.push( new Broods(
                    queenBee.scene,
                    closestCellToBot.x,
                    closestCellToBot.y,
                    'egg.png',
                    queenBee.username,
                    closestCellToBot)
                );
                utility.setDepthOfGroups(queenBee.scene);
                queenBee.recentlyLaidEgg = true;
                setTimeout(function()
                {
                    queenBee.recentlyLaidEgg = false;
                    queenBee.queenBeeSprite.task = 'headingToNearestCell';
                    // console.log('Bot no longer recently laid egg.');
                }, 3000);
            } else {
                console.log('Closest cell was too far away.');
            }

        } else {
            // console.log('There are no empty cells.');
        }
    },

    botNewHive: function (queenBee)
    {
        queenBee.scene.hives.push( new Hives(
            queenBee.scene,
            queenBee.queenBeeSprite.x,
            queenBee.queenBeeSprite.y,
            queenBee)
        );
        utility.setDepthOfGroups(queenBee.scene);
        queenBee.recentlyPlacedNewHive = true;
        setTimeout(function()
        {
            queenBee.recentlyPlacedNewHive = false;
        }, 3000);
        queenBee.queenBeeSprite.newHiveDestinationX = null;
        queenBee.queenBeeSprite.newHiveDestinationY = null;
        queenBee.queenBeeSprite.target = utility.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
        queenBee.queenBeeSprite.task = 'headingToNearestCell';
    },

    botDetermineWaspThreat: function (queenBee)
    {
        let closestWasp = utility.closestWasp(queenBee.scene, queenBee.queenBeeSprite);
        if (closestWasp)
        {
            let distanceToClosestWasp = Phaser.Math.Distance.Between(
                queenBee.queenBeeSprite.x,
                queenBee.queenBeeSprite.y,
                closestWasp.x,
                closestWasp.y
            );
            if (distanceToClosestWasp < queenBee.dangerZone)
            {
                queenBee.botAlarmPheromoneOn(queenBee);
            } else {
                queenBee.botDetermineQueenBeeThreat(queenBee);
            }
        } else {
            queenBee.botDetermineQueenBeeThreat(queenBee);
        }
    },

    botDetermineQueenBeeThreat: function (queenBee)
    {
        let closestEnemyQueenBee = utility.closestEnemyQueenBee(queenBee.scene, queenBee.queenBeeSprite);
        if (closestEnemyQueenBee)
        {
            let distanceToClosestEnemyQueenBee = Phaser.Math.Distance.Between(
                queenBee.queenBeeSprite.x,
                queenBee.queenBeeSprite.y,
                closestEnemyQueenBee.x,
                closestEnemyQueenBee.y
            );
            if (distanceToClosestEnemyQueenBee < queenBee.dangerZone &&
                closestEnemyQueenBee.parent.alarmPheromoneActive == true)
            {
                queenBee.botAlarmPheromoneOn(queenBee);
            } else {
                queenBee.botDetermineWorkerThreat(queenBee);
            }
        } else {
            queenBee.botDetermineWorkerThreat(queenBee);
        }
    },

    botDetermineWorkerThreat: function (queenBee)
    {
        let closestEnemyWorker = utility.closestEnemyWorker(queenBee.scene, queenBee.queenBeeSprite);
        if (closestEnemyWorker)
        {
            let distanceToClosestEnemyWorker = Phaser.Math.Distance.Between(
                queenBee.queenBeeSprite.x,
                queenBee.queenBeeSprite.y,
                closestEnemyWorker.x,
                closestEnemyWorker.y
            );
            if (distanceToClosestEnemyWorker < queenBee.dangerZone &&
                closestEnemyWorker.alarmPheromoneParticles.emitting)
            {
                queenBee.botAlarmPheromoneOn(queenBee);
            } else {
                queenBee.botDetermineVarroaMiteThreat(queenBee);
            }
        } else {
            queenBee.botDetermineVarroaMiteThreat(queenBee);
        }
    },

    botDetermineVarroaMiteThreat: function (queenBee)
    {
        let closestVarroaMite = utility.closestVarroaMite(queenBee.scene, queenBee.queenBeeSprite);
        if (closestVarroaMite)
        {
            let distanceToClosestVarroaMite = Phaser.Math.Distance.Between(
                queenBee.queenBeeSprite.x,
                queenBee.queenBeeSprite.y,
                closestVarroaMite.x,
                closestVarroaMite.y
            );
            if (closestVarroaMite < queenBee.dangerZone)
            {
                queenBee.botAlarmPheromoneOn(queenBee);
            } else {
                queenBee.botAlarmPheromoneOff(queenBee);
            }
        } else {
            queenBee.botAlarmPheromoneOff(queenBee);
        }
    },

    botAlarmPheromoneOn: function (queenBee)
    {
        if (!queenBee.queenBeeSprite.alarmPheromoneActive)
        {
            queenBee.queenBeeSprite.alarmPheromoneActive = true;
            queenBee.alarmPheromoneActive = true;
            queenBee.alarmPheromoneParticles.emitting = true;
            utility.workersOfQueenBee(queenBee).forEach(worker => {
                worker.alarmPheromoneParticles.emitting = true;
            });
        }
    },

    botAlarmPheromoneOff: function (queenBee)
    {
        if (queenBee.queenBeeSprite.alarmPheromoneActive)
        {
            queenBee.queenBeeSprite.alarmPheromoneActive = false;
            queenBee.alarmPheromoneActive = false;
            queenBee.alarmPheromoneParticles.emitting = false;
            utility.workersOfQueenBee(queenBee).forEach(worker => {
                worker.alarmPheromoneParticles.emitting = false;
            });
        }
    }

});

export var Workers = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Workers (scene, x, y, username, birthOrder, colonyName, species)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;
        this.colonyName = colonyName;
        this.species = species;

        if (!this.species)
        {
            this.species = 'mellifera';
        }

        // Add shadow
        switch(this.species)
        {
            case 'mellifera':
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
                break;
            case 'melliferaCat':
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinCat.png');
                break;
            case 'melliferaBlue':
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinBlue.png');
                break;
            case 'melliferaViolet':
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinViolet.png');
                break;
            case 'bumble':
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeWorker.png');
                break;
            default:
                this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
                break;
        }
        this.workerShadowSprite.tint = 0x3c2040;
        this.workerShadowSprite.alpha = .1;

        this.enableSpine = this.scene.enableSpine;

        // Add main sprite
        switch(this.species)
        {
            case 'mellifera':
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
            break;
            case 'melliferaCat':
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinCat.png');
                break;
            case 'melliferaBlue':
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinBlue.png');
                break;
            case 'melliferaViolet':
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeWorkerSkinViolet.png');
                break;
            case 'bumble':
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeWorker.png');
                break;
            default:
                this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
                break;
        }

        this.workerSprite.parent = this;
        scene.workersGroup.add(this.workerSprite);
        this.workerSprite.setSize(60, 60);
        this.workerSprite.setBounce(1, 1);
        // this.workerSprite.body.setMass(.5);
        // this.workerSprite.body.setDrag(.5);
        // this.workerSprite.setDamping(true);
        // this.workerSprite.body.setFriction(.1);
        this.workerSprite.body.collideWorldBounds = true;
        this.workerSprite.body.stopVelocityOnCollide = false;
        this.workerSprite.workerShadowSprite = this.workerShadowSprite;

        if (this.enableSpine)
        {
            this.workerSprite.enableSpine = this.enableSpine;
            this.workerSprite.setAlpha(.000000000000000000001);
            // Create Spine object
            this.workerSprite.animation = 'idle';
            this.workerSpine = scene.add.spine(400, 600, 'worker', this.workerSprite.animation, true);
            this.scale = .25;
            this.workerSpine.setScale(0, 0);
            this.workerSpine.setDepth(9);
            this.workerSpine.animation = this.workerSprite.animation;
            this.workerSpine.parent = this;
            this.workerSprite.workerSpine = this.workerSpine;
            // scene.workersGroup.add(this.workerSpine);

            // Set Spine skins
            let selectedSkin = this.workerSpine.skeletonData.skins.find(skin => skin.name == species);
            this.workerSpine.setSkin(selectedSkin);

            this.scale = .3;
            this.workerSprite.scaleInTweenComplete = false;
            var scaleInTween = scene.tweens.add({
                targets: this.workerSpine,
                scaleX: this.scale,
                scaleY: this.scale,
                duration: scene.workerScaleInDuration,
                ease: 'Sine',
                onCompleteScope: this,
                onComplete: scaleInTweenOnComplete
            });

            function scaleInTweenOnComplete()
            {
                try {
                    // Fix for workers dying before spine is done
                    // scaling in crashing the Spine plugin.
                    this.targets[0].parent.workerSprite.scaleInTweenComplete = true;
                } catch (error) {
                    console.error('There was an error setting to true on a worker:', error);
                }
            }
        }

        this.workerSprite.username = this.username;
        this.workerSprite.birthOrder = this.birthOrder;
        this.workerSprite.species = this.species;

        // What is this bee carrying?
        this.workerSprite.carryingNectar = false;
        this.workerSprite.carryingBeeBread = false;
        this.workerSprite.pollenCarriedGroup = scene.physics.add.group();
        this.workerSprite.beeBreadCarriedGroup = scene.physics.add.group();
        this.workerSprite.varroaMitesCarriedGroup = scene.physics.add.group();
        scene.physics.add.overlap(this.workerSprite.beeBreadCarriedGroup, scene.broodsGroup, colliderCallbacks.beeBreadTouchedBrood);
        this.workerSprite.pollenCarriedGroup.setDepth(50);
        this.workerSprite.beeBreadCarriedGroup.setDepth(50);
        this.workerSprite.varroaMitesCarriedGroup.setDepth(50);

        // What are this bee's needs and status?
        this.workerSprite.isWorker = true;
        this.workerSprite.isHungry = true;
        this.workerSprite.hitPoints = 100;
        this.workerSprite.hasMites = false;
        this.workerSprite.task = 'headingToGroomWorkerWithMites';
        this.workerSprite.isBeingGroomed = false;
        this.workerSprite.dangerZone = 750;

        // Create health bar
        var rect = new Phaser.Geom.Rectangle(0, 0, this.workerSprite.hitPoints, 15);
        this.workerSprite.healthBar = scene.add.graphics({ fillStyle: { color: 0xf2dd89 } });
        this.workerSprite.healthBar.fillRectShape(rect);
        scene.uiGroup.add(this.workerSprite.healthBar);
        this.workerSprite.healthBar.alpha = 0;

        // Create a ParticleEmitterManager for the alarm pheromone particles.
        this.alarmPheromoneParticles = scene.add.particles(0, 0, 'sprites', {
            frame: 'alarm.png',
            speed: 100,
            gravityX: 0,
            gravityY: 0,
            scale: { start: 0.1, end: 1 },
            lifespan: 1000,
            frequency: 250,
            follow: this.workerSprite
        });
        this.alarmPheromoneParticles.emitting = false; // Disable the emitter initially.
        this.workerSprite.alarmPheromoneParticles = this.alarmPheromoneParticles;

        this.workerSprite.numberOfCellsWorkerCanBuildBeforeEating = 0;

        this.workerSprite.scene.numberOfLocalWorkers += 1;

        // if (this.workerSprite.username == 'Bot')
        // {
        //     console.log('This is a bot.');
        // }

        // What is this bee's job?
        var randomRole = Phaser.Math.RND.pick(scene.workerRoles);
        this.workerSprite.role = randomRole;
        this.workerSprite.targetRecentlyChanged = false;
        this.workerSprite.recentlyTouchedBuilableCell = false;
        this.isPlayerWorker = false;
        if (this.username == scene.queenBees[0].username)
        {
            this.isPlayerWorker = true;

            // Create role selection sprite.
            this.workerSprite.selectorSprite = scene.physics.add.sprite(x, y, 'sprites', 'beeSelector.png');
        }
        switch (this.workerSprite.role)
        {
            case 'forager':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.plantsGroup.children.entries);
                this.workerSprite.task = 'Heading to forage flowers.';
                if (this.isPlayerWorker)
                {
                    this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerActive.png');
                    this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseInactive.png');
                    this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderInactive.png');
                }
                break;
            case 'nurse':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                this.workerSprite.task = 'Heading to a hive cell.';
                if (this.isPlayerWorker)
                {
                    this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerInactive.png');
                    this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseActive.png');
                    this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderInactive.png');
                }
                break;
            case 'builder':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                this.workerSprite.task = 'Heading to a hive cell.';
                if (this.isPlayerWorker)
                {
                    this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerInactive.png');
                    this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseInactive.png');
                    this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderActive.png');
                }
                break;
        }

        if (this.isPlayerWorker)
        {
            this.workerSprite.selectorForagerSprite.setOrigin(0.5, 0);
            this.workerSprite.selectorNurseSprite.setOrigin(0.5, 0);
            this.workerSprite.selectorBuilderSprite.setOrigin(0.5, 0);

            this.workerSprite.selectorForagerSprite.alpha = 0;
            this.workerSprite.selectorNurseSprite.alpha = 0;
            this.workerSprite.selectorBuilderSprite.alpha = 0;
            this.workerSprite.selectorSprite.alpha = 0;

            scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorSprite);
            scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorForagerSprite);
            scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorNurseSprite);
            scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorBuilderSprite);
            scene.workerSelectionSpritesGroup.add(this.workerSprite.healthBar);

            // Set worker sprite click event.
            this.workerSprite.setInteractive();
            if (this.username == scene.queenBees[0].username)
            {

                this.workerSprite.on('pointerdown', function () {

                    if (!this.selected)
                    {
                        this.selected = true;
                        var childrenWorkerSelectionSprites = scene.workerSelectionSpritesGroup.getChildren();
                        for (var i = 0; i < childrenWorkerSelectionSprites.length; i++)
                        {
                            childrenWorkerSelectionSprites[i].alpha = 0;
                        }
                        this.scene.tweens.add({
                            targets: [
                                this.selectorSprite,
                                this.selectorForagerSprite,
                                this.selectorNurseSprite,
                                this.selectorBuilderSprite,
                                this.healthBar
                            ],
                            alpha: 1,
                            duration: 250,
                            ease: 'Sine'
                        });
                    } else {
                        this.selected = false;
                        this.scene.tweens.add({
                            targets: [
                                this.selectorSprite,
                                this.selectorForagerSprite,
                                this.selectorNurseSprite,
                                this.selectorBuilderSprite,
                                this.healthBar
                            ],
                            alpha: 0,
                            duration: 250,
                            ease: 'Sine'
                        });
                    }
                });

                // Set a reference to the parent sprite on each button.
                this.workerSprite.selectorForagerSprite.parent = this.workerSprite;
                this.workerSprite.selectorNurseSprite.parent = this.workerSprite;
                this.workerSprite.selectorBuilderSprite.parent = this.workerSprite;

                // Set job selection click events.
                this.workerSprite.selectorForagerSprite.setInteractive();
                this.workerSprite.selectorForagerSprite.on('pointerdown', function () {
                    if (this.frame.name == 'foragerInactive.png')
                    {
                        this.setTexture('sprites', 'foragerActive.png');
                        this.parent.role = 'forager';
                        this.parent.target = Phaser.Math.RND.pick(scene.plantsGroup.children.entries);
                        this.parent.task = 'Heading to forage flowers.';
                    } else {
                        // this.setTexture('sprites', 'foragerInactive.png');
                    }
                    // console.log('foragerSprite', this);
                    this.parent.selectorNurseSprite.setTexture('sprites', 'nurseInactive.png');
                    this.parent.selectorBuilderSprite.setTexture('sprites', 'builderInactive.png');
                });
                this.workerSprite.selectorNurseSprite.setInteractive();
                this.workerSprite.selectorNurseSprite.on('pointerdown', function () {
                    if (this.frame.name == 'nurseInactive.png')
                    {
                        this.setTexture('sprites', 'nurseActive.png');
                        this.parent.role = 'nurse';

                        // Determine nearest varroa-infested cell.
                        let closestBroodWithMites = utility.closestBroodWithMites(scene, this.parent);
                        let distanceToClosestBroodWithMites;
                        if (closestBroodWithMites)
                        {
                            distanceToClosestBroodWithMites = Phaser.Math.Distance.Between(this.parent.x, this.parent.y, closestBroodWithMites.x, closestBroodWithMites.y);
                        }

                        // Determine nearest varroa-infested worker.
                        let closestWorkerWithMites = utility.closestWorkerWithMites(scene, this.parent);
                        let distanceToClosestWorkerWithMites;
                        if (closestWorkerWithMites)
                        {
                            distanceToClosestWorkerWithMites = Phaser.Math.Distance.Between(this.parent.x, this.parent.y, closestWorkerWithMites.x, closestWorkerWithMites.y);
                        }

                        // Determine target.
                        if (distanceToClosestBroodWithMites &&
                            distanceToClosestBroodWithMites < 700)
                        {
                            this.parent.task = 'Heading to groom a brood with mites.';
                            this.parent.target = closestBroodWithMites;

                        } else if (distanceToClosestWorkerWithMites && distanceToClosestWorkerWithMites < 700)
                        {
                            this.parent.task = 'Heading to groom a worker with mites.';
                            this.parent.target = closestWorkerWithMites;
                        } else {
                            this.parent.task = 'Heading to a cell.';
                            this.parent.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                        }
                    } else {
                        // this.setTexture('sprites', 'nurseInactive.png');
                    }
                    this.parent.selectorForagerSprite.setTexture('sprites', 'foragerInactive.png');
                    this.parent.selectorBuilderSprite.setTexture('sprites', 'builderInactive.png');
                });
                this.workerSprite.selectorBuilderSprite.setInteractive();
                this.workerSprite.selectorBuilderSprite.on('pointerdown', function () {
                    if (this.frame.name == 'builderInactive.png')
                    {
                        this.setTexture('sprites', 'builderActive.png');
                        this.parent.role = 'builder';
                        this.parent.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                        this.parent.task = 'Heading to build hive cells.';
                    } else {
                        // this.setTexture('sprites', 'builderInactive.png');
                    }
                    this.parent.selectorForagerSprite.setTexture('sprites', 'foragerInactive.png');
                    this.parent.selectorNurseSprite.setTexture('sprites', 'nurseInactive.png');
                });

            }
        }

        // Make it wiggle.
        let wiggleAmount;
        switch(species)
        {
            case 'mellifera':
                wiggleAmount = 0;
                break;
            case 'bumble':
                wiggleAmount = .075;
                break;
            default:
                wiggleAmount = 0;
                break;
        }
        this.wiggle = scene.tweens.addCounter({
            from: -wiggleAmount,
            to: wiggleAmount,
            duration: 200,
            yoyo: true,
            repeat: -1,
            ease: 'Cubic.easeInOut'
        });

        if (scene.enableSound)
        {
            // Play Buzzing Sound.
            let buzzSounds = ['beeBuzz1', 'beeBuzz2', 'beeBuzz3', 'beeBuzz4', 'beeBuzz5', 'beeBuzz6'];
            var randomBuzzSound = Phaser.Math.RND.pick(buzzSounds);
            this.buzzingSound = scene.sound.add(randomBuzzSound);
            var loopMarker = {
                name: 'loop',
                config: {
                    loop: true,
                    volume: 0.005
                }
            };
            this.workerSprite.buzzingSound = this.buzzingSound;
            this.buzzingSound.addMarker(loopMarker)
            this.buzzingSound.play('loop');
        }

    },

    workerGroomsWorker(worker1, worker2) {
        // console.log('Grooming in progress...', worker1, worker2);
        worker1.isBeingGroomed = true;
        worker2.isBeingGroomed = true;

        // Save old target for after grooming is done.
        let worker1OldTarget = worker1.target;
        let worker2OldTarget = worker2.target;

        // Both workers choose each other as their target.
        worker1.target = worker2;
        worker2.target = worker1;

        let groomingTask = 'grooming';
        worker1.task = groomingTask;
        worker2.task = groomingTask;

        // Set a timer for how long to groom for.
        setTimeout(function()
        {
            // console.log('Grooming complete.');
            worker1.isBeingGroomed = false;
            worker2.isBeingGroomed = false;

            // remove mites from both,
            var childrenVarroaMites1 = worker1.varroaMitesCarriedGroup.getChildren();
            for (var i = 0; i < childrenVarroaMites1.length; i++)
            {
                childrenVarroaMites1[i].varroaMiteShadowSprite.destroy();
                childrenVarroaMites1[i].destroy();
            }
            var childrenVarroaMites2 = worker2.varroaMitesCarriedGroup.getChildren();
            for (var i = 0; i < childrenVarroaMites2.length; i++)
            {
                childrenVarroaMites2[i].varroaMiteShadowSprite.destroy();
                childrenVarroaMites2[i].destroy();
            }

            worker1.hasMites = false;
            worker2.hasMites = false;

            // If old target is same as current one (we know this will be a nurse),
            // Set new target to nearest cell.
            // If old targer not the same as current one, set target back to old.
            if (worker1.target == worker1OldTarget)
            {
                worker1.target == utility.closestCell(worker1.scene, worker1);
            } else {
                worker1.target = worker1OldTarget;
            }
            if (worker2.target == worker2OldTarget)
            {
                worker2.target == utility.closestCell(worker2.scene, worker2);
            } else {
                worker2.target = worker2OldTarget;
            }

        }, 2000);
    },

    workerGroomsBrood(worker, brood) {
        brood.isBeingGroomed = true;

        let groomingTask = 'grooming';
        worker.task = groomingTask;

        // Set a timer for how long to groom for.
        setTimeout(function()
        {
            brood.isBeingGroomed = false;

            // remove mites from both,
            var childrenVarroaMites = brood.varroaMitesCarriedGroup.getChildren();
            for (var i = 0; i < childrenVarroaMites.length; i++)
            {
                childrenVarroaMites[i].varroaMiteShadowSprite.destroy();
                childrenVarroaMites[i].destroy();
            }

            brood.hasMites = false;

            if (worker.scene)
            {
                worker.target = utility.closestCell(worker.scene, worker);
                worker.task = 'Heading to nearest hive cell.';
            }
        }, 2000);
    },

    update: function (worker)
    {
        try {
            // Set Max Speed
            let speed;
            switch(worker.scene.selectedSpecies)
            {
                case 'mellifera':
                    speed = worker.scene.melliferaWorkerSpeed;
                    break;
                case 'bumble':
                    speed = worker.scene.bumbleWorkerSpeed;
                    acceleration = worker.scene.bumbleWorkerAccelerationSpeed;
                    break;
                default:
                    speed = worker.scene.melliferaWorkerSpeed;
                    acceleration = worker.scene.melliferaWorkerAccelerationSpeed;
                    break;
            }
            let acceleration = speed * 3;

            for (var q = 0; q < worker.scene.queenBees.length; q++)
            {
                var currentQueen = worker.scene.queenBees[q];

                if (currentQueen.username == worker.username)
                {
                    // Follow the queen if her pheromone is active.
                    if (currentQueen.followPheromoneActive)
                    {
                        worker.workerSprite._rotation = worker.scene.physics.accelerateToObject(
                            worker.workerSprite,
                            currentQueen.queenBeeSprite,
                            acceleration,
                            speed,
                            speed
                        ) + worker.wiggle.getValue();
                    } else if (currentQueen.alarmPheromoneActive)
                    {
                        // Or be aggressive if alarmPheromone is active.
                        // Target wasps first, then other bees or mites—whatever is closest.
                        var closestWasp = utility.closestWasp(worker.scene, worker.workerSprite);
                        var closestYellowJacket = utility.closestYellowJacket(worker.scene, worker.workerSprite);
                        let distanceToClosestWasp;
                        let distanceToClosestYellowJacket;

                        // Target wasps first, yellowJackets second, worker, queenBee, mite
                        if (closestWasp &&
                            closestYellowJacket)
                        {

                            distanceToClosestWasp = Phaser.Math.Distance.Between(closestWasp.x, closestWasp.y, worker.workerSprite.x, worker.workerSprite.y);
                            distanceToClosestYellowJacket = Phaser.Math.Distance.Between(closestYellowJacket.x, closestYellowJacket.y, worker.workerSprite.x, worker.workerSprite.y);
                            if (distanceToClosestWasp < distanceToClosestYellowJacket)
                            {
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestWasp, acceleration, speed, speed ) + worker.wiggle.getValue();
                            } else {
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestYellowJacket, acceleration, speed, speed ) + worker.wiggle.getValue();
                            }
                        } else if (closestYellowJacket) {
                            distanceToClosestYellowJacket = Phaser.Math.Distance.Between(closestYellowJacket.x, closestYellowJacket.y, worker.workerSprite.x, worker.workerSprite.y);
                            if (distanceToClosestYellowJacket < worker.workerSprite.dangerZone)
                            {
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestYellowJacket, acceleration, speed, speed ) + worker.wiggle.getValue();
                            }
                        } else if (closestWasp) {
                            distanceToClosestWasp = Phaser.Math.Distance.Between(closestWasp.x, closestWasp.y, worker.workerSprite.x, worker.workerSprite.y);
                            if (distanceToClosestWasp < worker.workerSprite.dangerZone)
                            {
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestWasp, acceleration, speed, speed ) + worker.wiggle.getValue();
                            }
                        } else {
                            // No wasps, so seek workers or queens or varroa mites.
                            var closestEnemyWorker = utility.closestEnemyWorker(worker.scene, worker.workerSprite);
                            var closestEnemyQueenBee = utility.closestEnemyQueenBee(worker.scene, worker.workerSprite);
                            var closestVarroaMite = utility.closestVarroaMite(worker.scene, worker.workerSprite);

                            // Get distance to nearest enemy worker.
                            if (closestEnemyWorker)
                            {
                                var distanceToClosestEnemyWorker = Phaser.Math.Distance.Between(worker.workerSprite.x, worker.workerSprite.y, closestEnemyWorker.x, closestEnemyWorker.y);
                            }

                            // Get distance to nearest mite.
                            if (closestVarroaMite)
                            {
                                var distanceToClosestVarroaMite = Phaser.Math.Distance.Between(worker.workerSprite.x, worker.workerSprite.y, closestVarroaMite.x, closestVarroaMite.y);
                            }

                            if (closestEnemyWorker && closestEnemyQueenBee)
                            {
                                // Who is closer, worker or queen?
                                var distanceToClosestEnemyQueenBee = Phaser.Math.Distance.Between(worker.workerSprite.x, worker.workerSprite.y, closestEnemyQueenBee.x, closestEnemyQueenBee.y);

                                if (distanceToClosestEnemyWorker < distanceToClosestEnemyQueenBee)
                                {
                                    // Attack nearest enemy worker.
                                    worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestEnemyWorker, acceleration, speed, speed ) + worker.wiggle.getValue();
                                } else if (distanceToClosestEnemyQueenBee < worker.scene.workerAggroRange) {
                                    // Attack nearest enemy queen.
                                    worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestEnemyQueenBee, acceleration, speed, speed ) + worker.wiggle.getValue();
                                } else if (closestVarroaMite && distanceToClosestVarroaMite < worker.scene.workerAggroRange)
                                {
                                    // Attack nearest varrow mite.
                                    worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestVarroaMite, acceleration, speed, speed ) + worker.wiggle.getValue();
                                } else {
                                    // There are no enemies to target, so just stick around your own queen.
                                    worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, currentQueen.queenBeeSprite, acceleration, speed, speed ) + worker.wiggle.getValue();
                                    worker.task = 'Following the queen.';
                                }
                            } else if (closestEnemyWorker && distanceToClosestEnemyWorker < worker.scene.workerAggroRange)
                            {
                                // Workers are the only target.
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestEnemyWorker, acceleration, speed, speed ) + worker.wiggle.getValue();
                            } else if (closestEnemyQueenBee && distanceToClosestEnemyQueenBee < worker.scene.workerAggroRange)
                            {
                                // Queens are the only target.
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestEnemyQueenBee, acceleration, speed, speed ) + worker.wiggle.getValue();
                            } else if (closestVarroaMite && distanceToClosestVarroaMite < 500)
                            {
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, closestVarroaMite, speed, speed, speed ) + worker.wiggle.getValue();
                            } else {
                                // There are no enemies to target, so just stick around your own queen.
                                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, currentQueen.queenBeeSprite, acceleration, speed, speed ) + worker.wiggle.getValue();
                                worker.task = 'Following the queen.';
                            }

                        }
                    } else if (worker.workerSprite.target && !worker.workerSprite.isBeingGroomed)
                    {
                        // Follow is off, alarm is off, you're not getting groomed, so do your own thing.
                        worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, worker.workerSprite.target, acceleration, speed, speed ) + worker.wiggle.getValue();
                    }

                    if (!worker.workerSprite.target)
                    {
                        worker.workerSprite.target = currentQueen.queenBeeSprite;
                        worker.task = 'Following the queen.';
                    }

                    // Update the position of all the pollen carried by the bee.
                    var childrenPollens = worker.workerSprite.pollenCarriedGroup.getChildren();
                    for (var i = 0; i < childrenPollens.length; i++)
                    {
                        var childrenPollensNewLocationTween = worker.scene.tweens.add({
                            targets: childrenPollens[i],
                            x: worker.workerSprite.x + childrenPollens[i].offsetWhenCarriedX,
                            y: worker.workerSprite.y + childrenPollens[i].offsetWhenCarriedY,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                    }

                    // Update the position of all the beeBread carried by the bee.
                    var childrenBeeBreads = worker.workerSprite.beeBreadCarriedGroup.getChildren();
                    for (var i = 0; i < childrenBeeBreads.length; i++)
                    {
                        var childrenBeeBreadsNewLocationTween = worker.scene.tweens.add({
                            targets: childrenBeeBreads[i],
                            x: worker.workerSprite.x,
                            y: worker.workerSprite.y,
                            angle: worker.workerSprite.angle,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                    }

                    // Update the position of all the varroaMites carried by the bee.
                    var childrenVarroaMites = worker.workerSprite.varroaMitesCarriedGroup.getChildren();
                    for (var i = 0; i < childrenVarroaMites.length; i++)
                    {
                        var childrenVarroaMitesNewLocationTween = worker.scene.tweens.add({
                            targets: childrenVarroaMites[i],
                            x: worker.workerSprite.x + childrenVarroaMites[i].offsetWhenCarriedX,
                            y: worker.workerSprite.y + childrenVarroaMites[i].offsetWhenCarriedY,
                            angle: worker.workerSprite.angle,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                    }

                    if (worker.username == worker.scene.queenBees[0].username &&
                        worker.workerSprite.selectorSprite)
                    {
                        // Adjust position of selector sprites.
                        var offset = 10;
                        var xOffset = 60;
                        var yOffset = 75;
                        var selectorSpriteNewLocationXTween = worker.scene.tweens.add({
                            targets: worker.workerSprite.selectorSprite,
                            x: worker.workerSprite.x,
                            y: worker.workerSprite.y + offset,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                        var selectorForagerSpriteNewLocationTween = worker.scene.tweens.add({
                            targets: worker.workerSprite.selectorForagerSprite,
                            x: worker.workerSprite.x - xOffset,
                            y: worker.workerSprite.y + yOffset,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                        var selectorNurseSpriteNewLocationTween = worker.scene.tweens.add({
                            targets: worker.workerSprite.selectorNurseSprite,
                            x: worker.workerSprite.x,
                            y: worker.workerSprite.y + yOffset,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });
                        var selectorBuilderSpriteNewLocationTween = worker.scene.tweens.add({
                            targets: worker.workerSprite.selectorBuilderSprite,
                            x: worker.workerSprite.x + xOffset,
                            y: worker.workerSprite.y + yOffset,
                            duration: worker.scene.objectUpdateRate,
                            ease: 'Linear',
                        });

                    }
                }

            }

            if (worker.enableSpine && worker.workerSpine.state)
            {
                // Adjust position of spine object
                this.workerSpine.setX(worker.workerSprite.x);
                this.workerSpine.setY(worker.workerSprite.y);
                this.workerSpine.setAngle(worker.workerSprite.angle);

                if (worker.workerSpine.state.tracks[0].animation.name != 'attack')
                {
                    // Change animation if not currently playing attack animation.
                    if (worker.workerSprite.body.speed >= 90)
                    {
                        if (worker.workerSpine.state.tracks[0].animation.name != 'flying')
                        {
                            // console.log('Worker now flying.');
                            worker.workerSpine.setAnimation(0, 'flying', true, 0);
                        }
                    } else if (worker.workerSprite.body.speed >= 10)
                    {
                        if (worker.workerSpine.state.tracks[0].animation.name != 'walking')
                        {
                            // console.log('Worker now walking.');
                            worker.workerSpine.setAnimation(0, 'walking', true, 0);
                        }
                    } else
                    {
                        if (worker.workerSpine.state.tracks[0].animation.name != 'idle')
                        {
                            // console.log('Worker now idle.');
                            worker.workerSpine.setAnimation(0, 'idle', true, 0);
                        }
                    }
                }



            }

            // Adjust position of shadow sprite.
            var offset = 10;
            var workerShadowSpriteNewLocationTween = worker.scene.tweens.add({
                targets: worker.workerShadowSprite,
                x: worker.workerSprite.x + offset,
                y: worker.workerSprite.y + offset,
                angle: worker.workerSprite.angle,
                duration: worker.scene.objectUpdateRate,
                ease: 'Linear',
            });

            // Adjust position of healthBar.
            worker.workerSprite.healthBar.setX(worker.workerSprite.x -(worker.workerSprite.width/2));
            worker.workerSprite.healthBar.setY(worker.workerSprite.y - 85);

            if (worker.scene.enableSound)
            {
                // Buzz volume increases closer to player queen.
                var target = worker.scene.queenBees[0].queenBeeSprite;
                var distance = Phaser.Math.Distance.Between(
                    worker.workerSprite.x, worker.workerSprite.y,
                    target.x, target.y
                );
                let volume;
                if (distance < 100)
                {
                    volume = .015;
                } else if (distance < 200)
                {
                    volume = .012;
                } else if (distance < 300)
                {
                    volume = .009;
                } else if (distance < 400)
                {
                    volume = .006;
                } else if (distance < 500)
                {
                    volume = .003;
                } else if (distance < 1000)
                {
                    volume = .0003;
                } else if (distance < 1500)
                {
                    volume = .0001;
                } else {
                    volume = 0;
                }
                worker.buzzingSound.volume = volume;
            }

        } catch(e) {
        	console.log('There was an error updating a worker: ', e);
        }



    },

    healthChange(worker, hurtOrHeal, amount)
    {

        try {
            let target;
            if (worker.workerSprite)
            {
                target = worker.workerSprite;
            } else {
                target = worker;
            }

            // Adjust hit point total.
            if (hurtOrHeal == 'hurt')
            {
                target.hitPoints -= amount;
            } else if (hurtOrHeal == 'heal') {
                target.hitPoints += amount;
            }
            // console.log('New total worker hitpoints: ', target.hitPoints);

            // Healthbar
            let healthBarXScale = target.hitPoints / 100;
            target.healthBar.setScale(healthBarXScale, 1);

            // Worker dies on 0 or fewer hit-points.
            if (target.hitPoints <= 0 && 
                worker.parent)
            {
                // console.log('A worker should be dead, with ', target.hitPoints, ' hit points.');
                worker.parent.dies(target);
            }

        } catch (e) {
            console.log('Error occured trying to set workerHealthBar: ', e);
            console.log('worker was: ', worker);
        }
    },

    dies: function (worker)
    {
        try
        {

            if (worker.scaleInTweenComplete)
            {
                if (worker.workerSpine)
                {
                    worker.workerSpine.destroy();
                }

                worker.scene.workersGroup.remove(worker);

                // Remove worker sprite and place a corpse sprite.
                let workerCorpse;
                switch(worker.species)
                {
                    case 'mellifera':
                        workerCorpse = worker.scene.physics.add.sprite(worker.x, worker.y, 'sprites', 'deadWorker.png');
                    break;
                    case 'bumble':
                        workerCorpse = worker.scene.physics.add.sprite(worker.x, worker.y, 'sprites', 'deadBumbleBeeWorker.png');
                        break;
                    default:
                        workerCorpse = worker.scene.physics.add.sprite(worker.x, worker.y, 'sprites', 'deadWorker.png');
                        break;
                }

                workerCorpse.angle = Phaser.Math.RND.integerInRange(0,359);
                worker.scene.tweens.add({
                    targets: workerCorpse,
                    alpha: 0,
                    duration: worker.scene.corpseFadeTime,
                    ease: 'Sine'
                });

                worker.alarmPheromoneParticles.emitting = false;

                if (worker.buzzingSound)
                {
                    worker.buzzingSound.pause();
                }

                // Destroy worker selection sprites.
                if (worker.selectorSprite)
                {
                    worker.selectorSprite.destroy();
                    worker.selectorForagerSprite.destroy();
                    worker.selectorNurseSprite.destroy();
                    worker.selectorBuilderSprite.destroy();
                    worker.healthBar.destroy();
                    console.log('Destroyed selection sprites.');
                }

                challengeLevels.tallyNumberOfWorkerScores(worker.scene);

                // Destroy worker and shadow sprite.
                worker.workerShadowSprite.destroy();
                worker.destroy();

            }

          } catch (err)
          {
              console.log('Error destroying worker.', err);
          }

    },


    setAttackAnimation: function (worker)
    {
    	try {
    		if (worker.workerSpine &&
    			worker.workerSpine.state.tracks[0].animation.name != 'attack')
    		{
    			let currentAnimation = worker.workerSpine.state.tracks[0].animation.name;
    			// console.log('Setting attack animation. Current animation:', currentAnimation);
    			worker.workerSpine.setAnimation(0, 'attack', false);
    			worker.workerSpine.addAnimation(0, currentAnimation, true, 0);
    		}
    	} catch (error) {
    		console.log('Error occurred when setting attack animation on worker: ', error);
    	}
    }

});

export var Drones = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Drones (scene, x, y, username, birthOrder)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;

        // Add shadow
        this.droneShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeDrone.png');
        this.droneShadowSprite.tint = 0x3c2040;
        this.droneShadowSprite.alpha = .1;

        // Add main sprite
        this.droneSprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyBeeDrone.png');
        scene.dronesGroup.add(this.droneSprite);
        this.droneSprite.setBounce(1, 1);
        this.droneSprite.body.stopVelocityOnCollide = false;
        this.droneSprite.setAlpha(0);
        this.droneSprite.droneShadowSprite = this.droneShadowSprite;

        var fadeInTween = scene.tweens.add({
            targets: this.droneSprite,
            alpha: '1',
            duration: 250,
            ease: 'Sine',
        });

        // Drone target
        let that = this;
        setTimeout(function()
        {
            that.droneSprite.target = utility.closestPlant(that.scene, that.droneSprite);
        }, 10);


        setTimeout(function()
        {
            scene.droneDies(that.droneSprite);
        }, 6000);

        // var pickANewTargetEvent = scene.time.addEvent(
        // {
        //     delay: 5000,
        //     callback: this.pickANewTarget,
        //     callbackScope: this,
        //     loop: true
        // });

        this.droneSprite.hitPoints = 100;
        this.droneSprite.birthOrder = birthOrder;
        this.droneSprite.task = 'Mate with a queen.';

    },

    pickANewTarget()
    {
        this.droneSprite.target = utility.closestQueenBee(this.scene, this.droneSprite);
    },

    dies: function (drone)
    {
          try {
              drone.scene.dronesGroup.remove(drone);

              // Remove drone sprite and place a corpse sprite.
              let droneCorpse;
              switch(drone.species)
              {
                  case 'mellifera':
                      droneCorpse = drone.scene.physics.add.sprite(drone.x, drone.y, 'sprites', 'deadWorker.png');
                  break;
                  case 'bumble':
                      droneCorpse = drone.scene.physics.add.sprite(drone.x, drone.y, 'sprites', 'deadBumbleBeeWorker.png');
                      break;
                  default:
                      droneCorpse = drone.scene.physics.add.sprite(drone.x, drone.y, 'sprites', 'deadWorker.png');
                      break;
              }

              droneCorpse.angle = Phaser.Math.RND.integerInRange(0,359);
              drone.scene.tweens.add({
                  targets: droneCorpse,
                  alpha: 0,
                  duration: drone.scene.corpseFadeTime,
                  ease: 'Sine'
              });

              // Destroy drone and shadow sprite.
              drone.droneShadowSprite.destroy();
              drone.destroy();
          } catch (err)
          {
              console.log('Error destroying drone.', err);
          }
    },

    update: function (drone)
    {
        // Only do these things if this drone originated on this client.
        if (drone.droneSprite.target &&
            drone.username == drone.scene.username)
        {
            drone.droneSprite._rotation = drone.scene.physics.accelerateToObject( drone.droneSprite, drone.droneSprite.target, 25, 100, 100 );
        }
        // Adjust position of shadow sprite.
        var offset = 10;
        drone.droneShadowSprite.x = drone.droneSprite.x + offset;
        drone.droneShadowSprite.y = drone.droneSprite.y + offset;
        drone.droneShadowSprite.angle = drone.droneSprite.angle;
    },
});

export var Hives = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Hives (scene, x, y, maker)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.species = scene.selectedSpecies;
        if (maker)
        {
            this.species = maker.species;
        }

        this.cellSprites = [];
        this.hivesGroup = scene.physics.add.group();
        var numberOfColumns = Phaser.Math.RND.integerInRange(2,3);
        if (maker && maker.species == 'yellowJacket')
        {
            numberOfColumns = Phaser.Math.RND.integerInRange(3,6);
        }
        var columnDirection = '';
        var directions = ['up', 'down'];
        var yOffsetDirection = 'up';
        var startX = x;
        var startY = y;
        var currentCellInColumn;
        var previousCellInColumn;

        for (var h = 0; h < numberOfColumns; h++)
        {
            // Change X and Y for each column.
            if (h != 0)
            {
                if (yOffsetDirection == 'up')
                {
                    yOffsetDirection = 'down';
                    x += 35;
                    y -= 25;
                } else {
                    yOffsetDirection = 'up';
                    x += 35;
                    y += 25;
                }
            }

            // Remove build to the right status from previous column.
            if (h != 0)
            {
                var childrenCellsBuildableToTheRight = scene.cellsThatCanBeBuiltUponToTheRightGroup.getChildren();
                for (var i = 0; i < childrenCellsBuildableToTheRight.length; i++)
                {
                    scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(childrenCellsBuildableToTheRight[i]);
                }
            }

            // First increase number of cells, then start decreasing them.
            if (h < (numberOfColumns/2))
            {
                cellsInColumn += 1;
            }
            else {
                cellsInColumn -= 1;
            }

            var cellsInColumn = Phaser.Math.RND.integerInRange(1,2);
            if (maker && maker.species == 'yellowJacket')
            {
                cellsInColumn = Phaser.Math.RND.integerInRange(3,6);
            }

            // Build cells up, then build them down.
            for (var j = 0; j < 2; j++)
            {

                switch(j)
                {
                    case 0:
                        columnDirection = 'up';
                        break;
                    case 1:
                        columnDirection = 'down';
                        break;
                }

                // Create cells in this column.
                for (var i = 0; i < cellsInColumn; i++)
                {

                    // Maybe this cell will have a grub in it, maybe it will be empty.
                    // var willAGrubFillThisCell = Phaser.Math.RND.integerInRange(0,1);
                    var willAGrubFillThisCell = 0;

                    if (willAGrubFillThisCell == 1)
                    {
                        var typeOfCell = 'brood';
                    } else
                    {
                        // Empty cell
                        var typeOfCell = 'empty';

                    }

                    // Place a cell, then work your way up or down adding cells from it.
                    switch(i) {
                        case 0:
                            scene.cells.push( currentCellInColumn = new Cells(
                                scene,
                                x,
                                y,
                                this,
                                typeOfCell,
                                true,
                                columnDirection,
                                scene.username,
                                this.species
                            ) );

                            break;
                        default:
                            // var offset = 10;
                            if (columnDirection == 'up')
                            {
                                scene.cells.push( currentCellInColumn = new Cells(
                                    scene,
                                    x,
                                    previousCellInColumn.cellSprite.y - (previousCellInColumn.cellSprite.height - 5),
                                    this,
                                    typeOfCell,
                                    true,
                                    columnDirection,
                                    scene.username,
                                    this.species
                                ) );

                            } else if (columnDirection == 'down')
                            {

                                scene.cells.push( currentCellInColumn = new Cells(
                                    scene,
                                    x,
                                    previousCellInColumn.cellSprite.y + (previousCellInColumn.cellSprite.height - 5),
                                    this,
                                    'empty',
                                    true,
                                    columnDirection,
                                    scene.username,
                                    this.species
                                ) );

                            }
                            break;
                    }

                    // Set the column number of this cell.
                    currentCellInColumn.cellSprite.columnNumber = h;
                    if (currentCellInColumn.cellSprite.columnNumber != 0)
                    {
                        scene.cellsThatCanBeBuiltUponToTheRightGroup.add(currentCellInColumn.cellSprite);
                    } else
                    {
                        scene.cellsThatCanBeBuiltUponToTheLeftGroup.add(currentCellInColumn.cellSprite);
                    }

                    // Designate the latest cell in this column as able to be built upon vertically.
                    currentCellInColumn.cellSprite.body.debugBodyColor = 0;
                    scene.cellsThatCanBeBuiltUponVerticallyGroup.add(currentCellInColumn.cellSprite);

                    // Take away the latest status from the previous cell in this column.
                    if (previousCellInColumn && i != (cellsInColumn - 1))
                    {
                        previousCellInColumn.canBeBuiltUpon = false;
                        previousCellInColumn.cellSprite.body.debugBodyColor = 16711935;
                        scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(previousCellInColumn.cellSprite);
                    }

                    // We are done with this cell, so set it as previous for the next one to reference.
                    previousCellInColumn = currentCellInColumn;
                }
            }




        }

    },

    update: function (time, delta)
    {

    }

});

export var Cells = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Cells (scene, x, y, parentHive, typeOfCell, canBeBuiltUpon, columnDirection, username, species)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        this.parentHive = parentHive;
        this.typeOfCell = typeOfCell;
        this.canBeBuiltUpon = canBeBuiltUpon;
        this.columnDirection = columnDirection;
        this.species = species;

        var shadowOffset = 5;

        // Add shadow sprite
        switch(species)
        {
            case 'mellifera':
                this.cellSpriteShadow = scene.physics.add.image(
                    x + shadowOffset,
                    y + shadowOffset,
                    'sprites', 'cell.png');
                break;
            case 'bumble':
                this.cellSpriteShadow = scene.physics.add.image(
                    x + shadowOffset,
                    y + shadowOffset,
                    'sprites', 'bumbleBeeCell.png');
                break;
            case 'yellowJacket':
                this.cellSpriteShadow = scene.physics.add.image(
                    x + shadowOffset,
                    y + shadowOffset,
                    'sprites', 'yellowJacketCell.png');
                break;
            default:
                this.cellSpriteShadow = scene.physics.add.image(
                    x + shadowOffset,
                    y + shadowOffset,
                    'sprites', 'cell.png');
                break;
        }

        this.cellSpriteShadow.tint = 0x3c2040;
        this.cellSpriteShadow.alpha = .1;
        // Shadow sprite scales in upon creation.
        this.cellSpriteShadow.scaleX = 0;
        this.cellSpriteShadow.scaleY = 0;
        scene.tweens.add({
            targets: this.cellSpriteShadow,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        // Add main sprite
        switch(species)
        {
            case 'mellifera':
                this.cellSprite = scene.physics.add.image( x, y, 'sprites', 'cell.png' );
                break;
            case 'bumble':
                this.cellSprite = scene.physics.add.image(x, y, 'sprites', 'bumbleBeeCell.png');
                break;
            case 'yellowJacket':
                this.cellSprite = scene.physics.add.image(
                    x + shadowOffset,
                    y + shadowOffset,
                    'sprites', 'yellowJacketCell.png');
                console.log('YellowJacket cell spawned.', species);
                break;
            default:
                this.cellSprite = scene.physics.add.image( x, y, 'sprites', 'cell.png' );
                break;
        }
        this.cellSprite.setInteractive();
        this.cellSprite.species = species;
        // Sprite scales in upon creation.
        this.cellSprite.scaleX = 0;
        this.cellSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.cellSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.cellsGroup.add(this.cellSprite);
        scene.hivesGroup.add(this.cellSprite);

        this.cellSprite.typeOfCell = typeOfCell;
        this.cellSprite.columnDirection = columnDirection;
        this.cellSprite.honeyStored = 0;
        this.cellSprite.pollenStorageGroup = scene.add.group();
        this.cellSprite.honeyStorageGroup = scene.add.group();

        this.cellSprite.parent = this;

        this.cellSprite.on('pointerdown', function () {
            this.parent.clickedCell(this);
        });

        switch (typeOfCell) {
            case 'brood':
                scene.broods.push( new Broods(scene, this.cellSprite.x, this.cellSprite.y) );
                break;
        }

    },

    clickedCell: function (cell)
    {
        var distanceBetweenCellAndQueen = Phaser.Math.Distance.Between(
    		cell.x,
    		cell.y,
    		cell.scene.queenBees[0].queenBeeSprite.x,
    		cell.scene.queenBees[0].queenBeeSprite.y);

    	// If this is the first time this has run and it's near the queen.
    	if (!cell.scene.previousTouchedCell && distanceBetweenCellAndQueen < 250 ||
    		!cell.scene.eggPreviewSprite)
    	{
    		cell.scene.eggPreviewSprite = cell.scene.physics.add.sprite(cell.x, cell.y, 'sprites', 'egg.png');
    		cell.scene.eggPreviewSprite.setMaxVelocity(0);
    		cell.scene.eggPreviewSprite.tint = 0xafd5aa;
    		cell.scene.eggPreviewSprite.alpha = 0.5;
    		var eggPreviewSpritePulsingTween = cell.scene.tweens.add({
    			targets: cell.scene.eggPreviewSprite,
    			alpha: '0.1',
    			duration: 500,
    			ease: 'Sine',
    			yoyo: true,
    			repeat: -1
    		});
    		cell.tint = 0xafd5aa;
    		cell.containsEggPreview = true;

    	}

    	// If this is not the first time this has run and it's near the queen.
    	if (cell.scene.previousTouchedCell && distanceBetweenCellAndQueen < 250)
    	{
    		try {
    			cell.scene.eggPreviewSprite.x = cell.x;
    			cell.scene.eggPreviewSprite.y = cell.y;
    			cell.containsEggPreview = true;
    			cell.tint = 0xafd5aa;
    			cell.scene.previousTouchedCell.tint = 16777215;
    			cell.scene.previousTouchedCell.containsEggPreview = false;
    		} catch (err)
    		{
    			console.log('Error: ', err);
    		}
    	}


    	cell.scene.selectedEggLayCell = cell;
    	cell.scene.previousTouchedCell = cell;
    },

    update: function (time, delta)
    {

    }

});

export var GreenSpaces = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function GreenSpaces (scene, x, y, angle, specieToSpawn, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        this.greenSpaceSprite = scene.physics.add.sprite(x, y, 'sprites', 'greenSpace.png');

        var numberOfPlantsOnThisPatch = 5;
        for (var i = 0; i < numberOfPlantsOnThisPatch; i++)
        {
            var randomX = Phaser.Math.RND.integerInRange(-550,550);
            var randomY = Phaser.Math.RND.integerInRange(-550,550);
            var randomPlantSpecie = Phaser.Math.RND.pick(scene.speciesOfPlant);
            var randomAngle = Phaser.Math.RND.integerInRange(0,360);
            scene.plants.push( new Plants(scene, this.greenSpaceSprite.x + randomX, this.greenSpaceSprite.y + randomY, randomAngle, randomPlantSpecie, scene.username) );
        }

        this.greenSpaceSprite.alpha = .5;
        if (angle)
        {
            this.greenSpaceSprite.angle = angle;
        }
        this.greenSpaceSprite.scaleX = 1.5;
        this.greenSpaceSprite.scaleY = 1.5;
        this.greenSpaceSprite.setMaxVelocity(0,0);
        scene.greenSpacesGroup.add(this.greenSpaceSprite);

    },

    update: function (time, delta)
    {

    }

});

export var Plants = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Plants (scene, x, y, angle, specie, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.specie = specie;
        this.username = username;

        var shadowOffset = 10;

        this.enableSpine = this.scene.enableSpine;

        // Add main sprite
        switch(specie) {
            case 'strawberry':
                // Add shadow
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'strawberry.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'strawberry.png');
                break;
            case 'lavender':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'lavender.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'lavender.png');
                break;
            case 'foxglove':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'foxglove.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'foxglove.png');
                break;
            case 'echinacea':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'echinacea.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'echinacea.png');
                break;
            default:
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'foxglove.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'foxglove.png');
                break;
        }

        this.plantSprite.plantShadowSprite = this.plantShadowSprite;
        this.plantShadowSprite.tint = 0x3c2040;
        this.plantShadowSprite.alpha = .1;

        this.plantShadowSprite.angle = angle;
        this.plantSprite.angle = angle
        this.plantSprite.setMaxVelocity(0,0);

        if (this.enableSpine)
        {
            this.plantSprite.enableSpine = this.enableSpine;
            this.plantSprite.setAlpha(0);
            // Create Spine object
            let skin = specie;
            this.plantSpine = scene.add.spine(400, 600, skin, 'animation', true);
            this.plantSpine.setScale(.5);
            this.plantSpine.setX(this.plantSprite.x);
            this.plantSpine.setY(this.plantSprite.y);
            this.plantSpine.setAngle(this.plantSprite.angle);
            this.plantSpine.setDepth(7);
            this.plantSpine.timeScale = .2;
            this.plantSprite.plantSpine = this.plantSpine;
            // scene.plantsGroup.add(this.plantSpine);
        }

        scene.plantsGroup.add(this.plantSprite);

    },

    update: function (time, delta)
    {

    }

});

export var Logs = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Logs (scene, x, y, angle, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        var shadowOffset = 10;

        this.logShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'log.png');
        this.logSprite = scene.physics.add.sprite(x, y, 'sprites', 'log.png');

        this.logShadowSprite.tint = 0x3c2040;
        this.logShadowSprite.alpha = .1;
        this.logShadowSprite.angle = angle;

        this.logSprite.angle = angle
        this.logSprite.setMaxVelocity(0,0);

        scene.logsGroup.add(this.logSprite);

    },

    update: function (time, delta)
    {

    }

});

export var Boulders = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Boulders (scene, x, y, angle, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        var randomSprite = Phaser.Math.RND.pick(scene.boulderSprites);

        var shadowOffset = 10;

        this.boulderShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', randomSprite);
        this.boulderSprite = scene.physics.add.sprite(x, y, 'sprites', randomSprite);

        this.boulderShadowSprite.tint = 0x3c2040;
        this.boulderShadowSprite.alpha = .1;
        this.boulderShadowSprite.angle = angle;

        this.boulderSprite.angle = angle
        this.boulderSprite.setMaxVelocity(0,0);

        scene.bouldersGroup.add(this.boulderSprite);

    },

    update: function (time, delta)
    {

    }

});

export var Ponds = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Ponds (scene, x, y, angle, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        this.pondSprite1 = scene.physics.add.sprite(x, y, 'sprites', 'pond1.png');
        this.pondSprite2 = scene.physics.add.sprite(x, y, 'sprites', 'pond2.png');
        this.pondSprite3 = scene.physics.add.sprite(x, y, 'sprites', 'pond3.png');

        this.pondSprite1.alpha = .5;
        this.pondSprite2.alpha = .5;
        this.pondSprite3.alpha = .5;

        scene.tweens.add({
            targets: this.pondSprite1,
            alpha: 1,
            duration: 2000,
            ease: 'Quadratic',
            repeat: -1,
            yoyo: true
        });
        scene.tweens.add({
            targets: this.pondSprite2,
            alpha: 1,
            duration: 2200,
            ease: 'Sine',
            repeat: -1,
            yoyo: true
        });
        scene.tweens.add({
            targets: this.pondSprite3,
            alpha: 1,
            duration: 1800,
            ease: 'Quadratic',
            repeat: -1,
            yoyo: true
        });

        if (angle)
        {
            this.pondSprite1.angle = angle;
            this.pondSprite2.angle = angle;
            this.pondSprite3.angle = angle;
        }

        this.pondSprite1.scaleX = 1.25;
        this.pondSprite1.scaleY = 1.25;

        this.pondSprite2.scaleX = 1.25;
        this.pondSprite2.scaleY = 1.25;

        this.pondSprite3.scaleX = 1.25;
        this.pondSprite3.scaleY = 1.25;

        this.pondSprite1.setMaxVelocity(0,0);
        this.pondSprite2.setMaxVelocity(0,0);
        this.pondSprite3.setMaxVelocity(0,0);

        scene.pondsGroup.add(this.pondSprite1);
        scene.pondsGroup.add(this.pondSprite2);
        scene.pondsGroup.add(this.pondSprite3);

        // Bubble Emitter
        this.particleConfig = {
            frame: ['bubble1.png', 'bubble2.png', 'bubble3.png'],
            x: { min: this.pondSprite1.x - this.pondSprite1.width/2, max: this.pondSprite1.x + this.pondSprite1.width/2 },
            y: { min: this.pondSprite1.y - this.pondSprite1.height/2, max: this.pondSprite1.y + this.pondSprite1.height/2 },
            speed: 0,
            gravity: {x: 0, y: 0},
            alpha: .2,
            scale: {start: 0.1, end: 1},
            lifespan: 2000
        }
        let bubbleParticles = scene.add.particles(0, 0, 'sprites', this.particleConfig);
    },

    update: function (time, delta)
    {
    }

});

export var Trees = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Trees (scene, x, y, angle, username)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;

        this.enableSpine = this.scene.enableSpine;

        // Add shadow
        this.shadowOffset = 100;
        this.treeShadowSprite = scene.physics.add.sprite(x + this.shadowOffset, y + this.shadowOffset, 'sprites', 'tree.png');
        this.treeShadowSprite.tint = 0x3c2040;
        this.treeShadowSprite.alpha = .1;
        this.treeShadowSprite.angle = angle;

        this.treeSprite = scene.physics.add.sprite(x, y, 'sprites', 'tree.png');
        this.treeSprite.alpha = 1;
        this.treeSprite.angle = angle;
        this.treeSprite.treeShadowSprite = this.treeShadowSprite;

        // scene.tweens.add({
        //     targets: this.treeSprite,
        //     alpha: 1,
        //     duration: 2000,
        //     ease: 'Quadratic',
        //     repeat: -1,
        //     yoyo: true
        // });

        if (this.enableSpine)
        {
            this.treeSprite.enableSpine = this.enableSpine;
            this.treeSprite.setAlpha(0);
            // Create Spine object
            this.treeSpine = scene.add.spine(400, 600, 'tree', 'animation', true);
            // this.treeSpine.setScale(.5);
            this.treeSpine.setX(this.treeSprite.x);
            this.treeSpine.setY(this.treeSprite.y);
            this.treeSpine.setAngle(this.treeSprite.angle);
            this.treeSpine.setDepth(7);
            // this.treeSpine.timeScale = .2;
            this.treeSprite.treeSpine = this.treeSpine;
        }

        if (angle)
        {
            this.treeShadowSprite.angle = angle;
            this.treeSprite.angle = angle;
        }

        this.treeSprite.scaleX = 1.25;
        this.treeSprite.scaleY = 1.25;

        this.treeSprite.setMaxVelocity(0,0);

        // scene.treesGroup.add(this.treeSprite);
        scene.plantsGroup.add(this.treeSprite);

    },

    update: function (time, delta)
    {
    }

});


export var Pollens = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Pollens (scene, x, y, username, birthOrder)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;

        var pollenSprites = ['pollen2.png', 'pollen1.png'];
        var chosenSprite = Phaser.Math.RND.pick(pollenSprites);
        this.pollenSprite = scene.physics.add.sprite(x, y, 'sprites', chosenSprite);
        this.pollenSprite.setSize(60, 60);
        this.pollenSprite.setDrag(.0001).setDamping().setMaxVelocity(5);

        this.pollenSprite.parent = this;
        // console.log(this.pollenSprite)

        // Pollen scales in upon creation
        this.pollenSprite.scaleX = 0;
        this.pollenSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.pollenSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.pollensGroup.add(this.pollenSprite);

        this.pollenSprite.offsetWhenCarriedX = Phaser.Math.RND.integerInRange(-20, 20);
        this.pollenSprite.offsetWhenCarriedY = Phaser.Math.RND.integerInRange(-20, 20);

        // Set a lifespan on the pollen.
        this.lifespanTimer = scene.time.delayedCall(60000, this.startsToDie(this.pollenSprite), [], this);

    },

    update: function (time, delta)
    {

    },

    startsToDie: function (pollen)
    {
        pollen.scene.tweens.add({
            targets: [pollen],
            alpha: 0,
            delay: 30000,
            duration: 3000,
            ease: 'Sine',
            onComplete:
                this.dies,
        });
    },

    dies: function (tween, target) {
        target[0].scene.pollensGroup.remove(target[0]);
        target[0].destroy();
    }




});

export var BeeBreads = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function BeeBreads (scene, x, y, username, birthOrder, species)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;
        this.species = species;

        switch(species)
        {
            case 'mellifera':
                this.beeBreadSprite = scene.physics.add.sprite(x, y, 'sprites', 'beeBread.png');
                break;
            case 'bumble':
                this.beeBreadSprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeBread.png');
                break;
            default:
                this.beeBreadSprite = scene.physics.add.sprite(x, y, 'sprites', 'beeBread.png');
                break;
        }
        this.beeBreadSprite.setSize( this.beeBreadSprite.width/2, this.beeBreadSprite.height/2 );
        this.beeBreadSprite.setDrag(.0001).setDamping().setMaxVelocity(5);
        this.beeBreadSprite.parent = null;
        this.beeBreadSprite.species = species;

        // Bee Bread scales in upon creation
        this.beeBreadSprite.scaleX = 0;
        this.beeBreadSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.beeBreadSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.beeBreadsGroup.add(this.beeBreadSprite);

        this.beeBreadSprite.offsetWhenCarriedX = Phaser.Math.RND.integerInRange(-20, 20);
        this.beeBreadSprite.offsetWhenCarriedY = Phaser.Math.RND.integerInRange(-20, 20);

        // Set a lifespan on the pollen.
        this.lifespanTimer = scene.time.delayedCall(60000, this.startsToDie(this.beeBreadSprite), [], this);

    },

    update: function (time, delta)
    {

    },

    startsToDie (beeBread)
    {
        try {
            beeBread.scene.tweens.add({
                targets: [beeBread],
                alpha: 0,
                delay: 30000,
                duration: 3000,
                ease: 'Sine',
                onComplete:
                    this.dies,
            });
        } catch (e) {
            console.log('There was an error when a bee bread started to die: ', e);
        }
    },

    dies(tween, target) {
        try {
            if (target[0].scene)
            {
                target[0].scene.beeBreadsGroup.remove(target[0]);
                target[0].destroy();
            }
        } catch (e) {
            console.log('There was an error when a bee bread died:', e);
        }
    }

});

export var Honeys = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Honeys (scene, x, y, username, birthOrder, cell, species)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;
        this.cell = cell;
        this.species = species;

        switch(species)
        {
            case 'mellifera':
                this.honeySprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyCell.png');
                break;
            case 'bumble':
                this.honeySprite = scene.physics.add.sprite(x, y, 'sprites', 'bumbleBeeHoney.png');
                break;
            default:
                this.honeySprite = scene.physics.add.sprite(x, y, 'sprites', 'honeyCell.png');
                break;
        }

        this.honeySprite.body.setCircle( this.honeySprite.width/2 );
        this.honeySprite.cell = cell;
        this.honeySprite.species;

        // Honey scales in upon creation
        this.honeySprite.scaleX = 0;
        this.honeySprite.scaleY = 0;
        scene.tweens.add({
            targets: this.honeySprite,
            scaleX: 1,
            scaleY: 1,
            alpha: .9,
            duration: 1000,
            ease: 'Sine'
        });

        scene.honeysGroup.add(this.honeySprite);

    },

    update: function (time, delta)
    {

    }

});

export var Broods = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Broods (scene, x, y, developmentalStage, username, birthCell)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthCell = birthCell;

        this.developmentalStages = ['egg.png', 'larva.png', 'pupa.png'];

        if (developmentalStage)
        {
            this.developmentalStage = developmentalStage;
        } else {
            this.developmentalStage = Phaser.Math.RND.pick(this.developmentalStages);
        }

        this.broodSprite = scene.physics.add.sprite(
            x,
            y,
            'sprites', this.developmentalStage
        );
        this.broodSprite.angle = Phaser.Math.RND.integerInRange(0,360);

        this.broodSprite.birthCell = birthCell;

        // Set animation tween on brood.
        switch(this.developmentalStage)
        {
            case 'egg.png':
                var eggWigglingTween = scene.tweens.add({
                    targets: this.broodSprite,
                    angle: '+=20',
                    duration: 500 + this.broodSprite.angle,
                    ease: 'Sine',
                    yoyo: true,
                    repeat: -1
                });
                break;
                case 'larva.png':
                    var larvaSpinningTween = scene.tweens.add({
                        targets: this.broodSprite,
                        angle: '+=360',
                        duration: 3000 + this.broodSprite.angle,
                        ease: 'Sine',
                        repeat: -1
                    });
                    break;
            default:
                var broodWigglingTween = scene.tweens.add({
                    targets: this.broodSprite,
                    angle: '+=20',
                    duration: 500 + this.broodSprite.angle,
                    ease: 'Sine',
                    yoyo: true,
                    repeat: -1
                });
                break;
        }

        // Brood scales in upon creation
        this.broodSprite.scaleX = 0;
        this.broodSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.broodSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        this.broodSprite.parent = this;

        switch (this.developmentalStage)
        {
            case 'egg.png':
                this.broodSprite.broodStage = 'egg';
                scene.tweens.add({
                    targets: this.broodSprite,
                    alpha: '0',
                    delay: 2000,
                    duration: 500,
                    ease: 'Sine',
                    onComplete: this.eggGrowsIntoLarva
                });
                break;
            case 'larva.png':
                this.broodSprite.broodStage = 'larva';
                break;
            case 'pupa.png':
                this.broodSprite.broodStage = 'pupa';
                break;
            case 'pupaYellowjacket.png':
                this.broodSprite.broodStage = 'pupaYellowjacket';
                break;
        }

        scene.broodsGroup.add(this.broodSprite);

        this.broodSprite.varroaMitesCarriedGroup = scene.physics.add.group();
        this.broodSprite.hasMites = false;
        this.broodSprite.isBeingGroomed = false;

    },

    eggGrowsIntoLarva: function (tween, broodSprite)
    {
        try {
            broodSprite[0].broodStage = 'larva';
            broodSprite[0].setTexture( 'sprites', 'larva.png');
            broodSprite[0].scene.tweens.add({
                targets: broodSprite[0],
                alpha: '1',
                duration: 500,
                ease: 'Sine',
            });
            utility.setDepthOfGroups(broodSprite[0].scene);
        } catch(e) {
        	console.log('There was an error when an egg grew into a larva: ', e);
        }

    },

    pupaBecomesWorker(tween, targets)
    {
        try
        {

            var newWorker;
            if (targets[0].scene)
            {
                let closestQueenBee = utility.closestQueenBee(targets[0].scene, targets[0]);

                targets[0].scene.workers.push( newWorker = new Workers(
                    targets[0].scene,
                    targets[0].x,
                    targets[0].y,
                    closestQueenBee.username,
                    targets[0].scene.workers.length,
                    closestQueenBee.parent.colonyName,
                    closestQueenBee.parent.species
                ));

                // Scale worker in.
                newWorker.workerSprite.scaleX = 0;
                var workerScalesInTween = targets[0].scene.tweens.add({
                    targets: newWorker.workerSprite,
                    scaleX: '1',
                    duration: 500,
                    ease: 'Sine'
                });

                utility.setDepthOfGroups(newWorker.scene);

                challengeLevels.tallyNumberOfWorkerScores(newWorker.scene);

                if (targets[0].birthCell)
                {
                    targets[0].birthCell.typeOfCell = 'empty';
                }

                targets[0].destroy();

                if (newWorker.scene.userData && (newWorker.scene.queenBees[0].username == closestQueenBee.username))
                {
                    userAccounts.addWorkersCreatedToUserAccount(newWorker.scene).then(function(res) {
                        // console.log('Response from adding workerCreated is: ', res)
                    });
                }

                if (newWorker.scene.userData && (newWorker.scene.queenBees[0].username == closestQueenBee.username))
                {
                    userAccounts.addHoneyToUserAccount(newWorker.scene, 1).then(function(res) {
                        // console.log('Response from adding honey is: ', res)
                    });
                }

            }

        } catch (e) {
            console.log('There was an error when pupa became worker:', e);
        }
    },

    update: function (time, delta)
    {

    },

    dies: function (brood)
    {
        // Fade out and remove brood sprite.
        if (brood.scene)
        {
            brood.scene.tweens.add({
                targets: brood,
                alpha: 0,
                duration: brood.scene.corpseFadeTime,
                ease: 'Sine',
                onComplete: removeBroodSprite
            });
        }


        function removeBroodSprite (tween, broodSprite)
        {
            // Destroy brood sprite.
            if (broodSprite[0].scene && broodSprite[0].birthCell)
            {
                broodSprite[0].birthCell.typeOfCell = 'empty';
                broodSprite[0].scene.broodsGroup.remove(broodSprite[0]);
            }
            broodSprite[0].destroy();
        }

    },

    removeBroodSprite: function (brood)
    {
        // Destroy brood sprite.
        target[0].scene.broodsGroup.remove(target[0]);
        target[0].destroy();
    }

});

export var Wasps = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Wasps (scene, x, y, username, birthOrder)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;

        this.enableSpine = this.scene.enableSpine;

        // Add shadow
        this.waspShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'wasp.png');
        this.waspShadowSprite.tint = 0x3c2040;
        this.waspShadowSprite.alpha = .1;

        // Add main sprite
        this.waspSprite = scene.physics.add.sprite(x, y, 'sprites', 'wasp.png');
        scene.waspsGroup.add(this.waspSprite);
        this.waspSprite.setBounce(1, 1);
        this.waspSprite.body.stopVelocityOnCollide = false;
        this.waspSprite.waspShadowSprite = this.waspShadowSprite;
        this.waspSprite.parent = this;

        if (this.enableSpine)
        {
            this.waspSprite.enableSpine = this.enableSpine;
            this.waspSprite.setAlpha(.000000000000000000001);
            // Create Spine object
            this.waspSprite.animation = 'idle';
            this.waspSpine = scene.add.spine(400, 600, 'wasp', this.waspSprite.animation, true);
            let scale = .5;
            // this.waspSpine.setScale(1);
            this.waspSpine.setDepth(9);
            this.waspSpine.animation = this.waspSprite.animation;
            this.waspSprite.waspSpine = this.waspSpine;
            // scene.waspsGroup.add(this.waspSpine);
            let skin = this.waspSpine.skeletonData.skins[1];
            this.waspSpine.setSkin(skin);

            var scaleInTween = scene.tweens.add({
                targets: this.waspSpine,
                scaleX: scale,
                scaleY: scale,
                duration: 1000,
                ease: 'Bounce',
            });

        }

        // Wasp target
        this.waspSprite.target = utility.closestWorker(this.scene, this.waspSprite);
        var pickANewTargetEvent = scene.time.addEvent(
        {
            delay: 5000,
            callback: this.pickANewTarget,
            callbackScope: this,
            loop: true
        });

        this.waspSprite.hitPoints = 175;
        this.waspSprite.birthOrder = birthOrder;
        this.waspSprite.task = 'kill';

        challengeLevels.tallyNumberOfGiantWasps(scene);

    },

    pickANewTarget()
    {
        try
        {
            // Retarget to yellow jacket if there are any and there are none close already.
            let closestYellowJacket = utility.closestYellowJacket(this.scene, this.waspSprite);
            let closestLarva = utility.closestLarva(this.scene, this.waspSprite);
            let closestWorker = utility.closestWorker(this.scene, this.waspSprite);

            if (closestWorker)
            {
                let distanceToClosestWorker = Phaser.Math.Distance.Between(
                    this.waspSprite.x, this.waspSprite.y,
                    closestWorker.x, closestWorker.y
                );
                if (distanceToClosestWorker < 750) {
                    // Seek out workers.
                    this.waspSprite.target = closestWorker;
                    console.log('Wasp seeking worker.');
                } else if (closestLarva) {
                    // If larva exists, seek out larva.
                    this.waspSprite.target = closestLarva;
                    console.log('Wasp seeking larva.');
                }
            }
        } catch (error) {
            console.log('Error occurred while wasp wasp trying to select a new target.', error);
        }

    },

    setAttackAnimation(wasp)
    {
    	try {
    		if (wasp.parent.waspSpine &&
    			wasp.parent.waspSpine.state.tracks[0].animation.name != 'attack')
    		{
    			let currentAnimation = wasp.parent.waspSpine.state.tracks[0].animation.name;
    			// console.log('Setting attack animation. Current animation:', currentAnimation);
    			wasp.parent.waspSpine.setAnimation(0, 'attack', false);
    			wasp.parent.waspSpine.addAnimation(0, currentAnimation, true, 0);
    		}
    	} catch (e) {
    		console.log('Error occurred when setting attack animation on wasp: ', error);
    	}
    },

    dies(wasp)
    {

        let scene = wasp.scene;

        // Remove wasp sprite and place a corpse sprite.
        let waspCorpse = wasp.scene.physics.add.sprite(wasp.x, wasp.y, 'sprites', 'deadWasp.png');
        waspCorpse.angle = Phaser.Math.RND.integerInRange(0,359);
        wasp.scene.tweens.add({
            targets: waspCorpse,
            alpha: 0,
            duration: wasp.scene.corpseFadeTime,
            ease: 'Sine'
        });

        // Destroy wasp shadow sprite.
        wasp.waspShadowSprite.destroy();

        //Destroy Wasp Spine object.
        if (wasp.waspSpine)
        {
            wasp.waspSpine.destroy();
        }

        wasp.scene.waspsGroup.remove(wasp);
        wasp.destroy();

        challengeLevels.tallyNumberOfGiantWasps(scene);
    },

    update: function (wasp)
    {

        // Only do these things if this wasp originated on this client.
        if (wasp.waspSprite.target &&
            wasp.username == wasp.scene.username)
        {
            wasp.waspSprite._rotation = wasp.scene.physics.accelerateToObject( wasp.waspSprite, wasp.waspSprite.target, 25, 100, 100 );
        }
        // Adjust position of shadow sprite.
        var offset = 10;
        wasp.waspShadowSprite.x = wasp.waspSprite.x + offset;
        wasp.waspShadowSprite.y = wasp.waspSprite.y + offset;
        wasp.waspShadowSprite.angle = wasp.waspSprite.angle;

        if (wasp.enableSpine)
        {
            // Adjust position of spine object
            this.waspSpine.setX(wasp.waspSprite.x);
            this.waspSpine.setY(wasp.waspSprite.y);
            this.waspSpine.setAngle(wasp.waspSprite.angle);

            if (wasp.waspSpine.state.tracks[0].animation.name != 'attack')
            {
                if (wasp.waspSprite.body.speed >= 10)
                {
                    if (wasp.waspSpine.state.tracks[0].animation.name != 'flying')
                    {
                        // console.log('Worker now flying.');
                        wasp.waspSpine.setAnimation(0, 'flying', true, 0);
                    }
                } else
                {
                    if (wasp.waspSpine.state.tracks[0].animation.name != 'idle')
                    {
                        // console.log('Worker now idle.');
                        wasp.waspSpine.setAnimation(0, 'idle', true, 0);
                    }
                }
            }
        }
    },
});

export var YellowJackets = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function YellowJackets (scene, x, y, username, birthOrder)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;
        this.species = 'yellowJacket';

        this.enableSpine = this.scene.enableSpine;

        // Add shadow
        this.yellowJacketShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'yellowJacket.png');
        this.yellowJacketShadowSprite.tint = 0x3c2040;
        this.yellowJacketShadowSprite.alpha = .1;

        // Add main sprite
        this.yellowJacketSprite = scene.physics.add.sprite(x, y, 'sprites', 'yellowJacket.png');
        scene.yellowJacketsGroup.add(this.yellowJacketSprite);
        this.yellowJacketSprite.setBounce(1, 1);
        this.yellowJacketSprite.body.stopVelocityOnCollide = false;
        this.yellowJacketSprite.yellowJacketShadowSprite = this.yellowJacketShadowSprite;
        this.yellowJacketSprite.username = username;
        this.yellowJacketSprite.parent = this;

        if (this.enableSpine)
        {
            this.yellowJacketSprite.enableSpine = this.enableSpine;
            this.yellowJacketSprite.setAlpha(.000000000000000000001);
            // Create Spine object
            this.yellowJacketSprite.animation = 'idle';
            this.yellowJacketSpine = scene.add.spine(400, 600, 'worker', this.yellowJacketSprite.animation, true);
            let scale = .4;
            // this.yellowJacketSpine.setScale(.4);
            this.yellowJacketSpine.setDepth(9);
            this.yellowJacketSpine.animation = this.yellowJacketSprite.animation;
            this.yellowJacketSprite.yellowJacketSpine = this.yellowJacketSpine;
            // scene.yellowJacketsGroup.add(this.yellowJacketSpine);
            // let skin = this.yellowJacketSpine.skeletonData.skins[8];
            let skin = this.yellowJacketSpine.skeletonData.skins.find(skin => skin.name == 'yellowJacket');
            this.yellowJacketSpine.setSkin(skin);

            var scaleInTween = scene.tweens.add({
                targets: this.yellowJacketSpine,
                scaleX: scale,
                scaleY: scale,
                duration: 1000,
                ease: 'Bounce',
            });
        }

        // var fadeInTween = scene.tweens.add({
        //     targets: this.yellowJacketSprite,
        //     alpha: '1',
        //     duration: 1000,
        //     ease: 'Sine',
        // });

        // Pick a new target every so often
        var pickANewTargetEvent = scene.time.addEvent(
        {
            delay: 5000,
            callback: this.pickANewTarget,
            callbackScope: this,
            loop: true
        });

        // Stats
        this.yellowJacketSprite.hitPoints = 125;
        this.yellowJacketSprite.birthOrder = birthOrder;
        this.yellowJacketSprite.task = 'kill';
        this.yellowJacketSprite.broodCarriedGroup = scene.physics.add.group();

        // Spawn a hive if there isn't already one.
        if (!scene.yellowJacketHive)
        {
            this.spawnHive(scene);
        }
        this.yellowJacketSprite.hive = scene.yellowJacketHive;

        // Yellow Jacket initial target is the player.
        this.yellowJacketSprite.target = scene.queenBees[0].queenBeeSprite;

        challengeLevels.tallyNumberOfYellowjacketsScores(scene);
    },

    spawnHive(scene)
    {
        let randomHiveLocation = Phaser.Math.RND.integerInRange(0, 3);
        let hiveX = 0;
        let hiveY = 0;
        let distanceOffset = 0;
        switch(randomHiveLocation)
        {
            case 0:
                hiveX = -(800 * 1) - distanceOffset;
                hiveY = -(600 * 1) - distanceOffset;
                break;
            case 1:
                hiveX = (800 * 1) + distanceOffset;
                hiveY = (600 * 1) + distanceOffset;
                break;
            case 2:
                hiveX = -(800 * 1) - distanceOffset;
                hiveY = -(600 * 1) - distanceOffset;
                break;
            case 3:
                hiveX = (800 * 1) + distanceOffset;
                hiveY = (600 * 1) + distanceOffset;
                break;
        }
        scene.hives.push(scene.yellowJacketHive = new Hives(
            scene,
            hiveX,
            hiveY,
            this)
        );
        utility.setDepthOfGroups(scene);
    },

    pickANewTarget()
    {
        try {

            let closestYellowJacket = utility.closestYellowJacket(this.scene, this.yellowJacketSprite);
            let closestLarva = utility.closestLarva(this.scene, this.yellowJacketSprite);
            let closestWasp = utility.closestWasp(this.scene, this.yellowJacketSprite);
            let closestWorker = utility.closestWorker(this.scene, this.yellowJacketSprite);
            let closestPlant = utility.closestPlant(this.scene, this.yellowJacketSprite);
            let closestEmptyYellowJacketCell = utility.closestEmptyYellowJacketCell(this.scene, this.yellowJacketSprite);

            if (this.yellowJacketSprite.task == 'headedBackToHiveWithBrood')
            {
                let closestYellowJacketBrood = utility.closestYellowJacketBrood(this.scene, this.yellowJacketSprite);
                if (closestYellowJacketBrood)
                {
                    this.yellowJacketSprite.target = closestYellowJacketBrood;
                    // console.log('Yellow jacket bringing stolen brood to nearest brood.');
                } else {
                    // There were no yellow jacket broods. Go to nearest yellow jacket cell.
                    if (closestEmptyYellowJacketCell) {
                        this.yellowJacketSprite.target = closestEmptyYellowJacketCell;
                        // console.log('Yellow jacket bringing stolen brood to nearest empty cell.');
                    } else {
                        // There were no empty yellow jacket cells either... just kill stuff.
                        yellowJacket.task = 'kill';
                        this.yellowJacketSprite.target = scene.queenBees[0].queenBeeSprite;
                    }
                }
            } else {
                // Not headed back to hive.
                if (closestYellowJacket)
                {
                    let distanceToClosestYellowJacket = Phaser.Math.Distance.Between(this.yellowJacketSprite.x, this.yellowJacketSprite.y, closestYellowJacket.x, closestYellowJacket.y);
                    if (distanceToClosestYellowJacket &&
                        distanceToClosestYellowJacket > 500)
                    {
                        this.yellowJacketSprite.target = closestYellowJacket;
                        // console.log('Yellow jacket seeking friends.');
                    } else if (closestWasp) {

                        let distanceToClosestWasp = Phaser.Math.Distance.Between(this.yellowJacketSprite.x, this.yellowJacketSprite.y, closestWasp.x, closestWasp.y);
                        if (distanceToClosestWasp && distanceToClosestWasp < 500)
                        {
                            this.yellowJacketSprite.target = closestWasp;
                            // console.log('Yellow jacket seeking wasp.');
                        } else if (closestLarva) {
                            this.yellowJacketSprite.target = closestLarva;
                            // console.log('Yellow jacket seeking larva.');
                        } else if (closestPlant) {
                            this.yellowJacketSprite.target = closestPlant;
                            // console.log('Yellow jacket seeking plant.');
                        }
                    } else if (closestWorker) {
                        this.yellowJacketSprite.target = closestWorker;
                        // console.log('Yellow jacket seeking worker.');
                    } else if (closestLarva) {
                        this.yellowJacketSprite.target = closestLarva;
                        // console.log('Yellow jacket seeking larva.');
                    } else {
                        this.yellowJacketSprite.target = closestEmptyYellowJacketCell;
                        // console.log('Yellow jacket going to nearest empty yellow jacket cell.');
                    }
                } else if (closestLarva) {
                    // If with buddies and larva exists, seek out larva.
                    this.yellowJacketSprite.target = closestLarva;
                    // console.log('Yellow jacket seeking larva.');
                }
            }

            if (closestEmptyYellowJacketCell)
            {
                let distanceToClosestYellowJacketCell = Phaser.Math.Distance.Between(this.yellowJacketSprite.x, this.yellowJacketSprite.y, closestEmptyYellowJacketCell.x, closestEmptyYellowJacketCell.y);
                if (distanceToClosestYellowJacketCell && distanceToClosestYellowJacketCell < 250 &&
                    !this.recentlyLaidEgg)
                {
                    // console.log('Yellow jacket laying egg in nearest empty yellow jacket cell.');
                    this.layEgg(this);
                }
            }

        } catch(e) {
        	console.log('There was an error when a yellowJacket tried to pick a new target: ', e);
        }

    },

    layEgg: function (yellowJacket)
    {
        try {

            // console.log('yellowJacket about to lay an egg:', yellowJacket);
            let closestEmptyYellowJacketCellToYellowJacket = utility.closestEmptyYellowJacketCell(yellowJacket.scene, yellowJacket);
            // console.log('closest cell for yellowjacket to lay an egg:', closestEmptyYellowJacketCellToYellowJacket);
            if (closestEmptyYellowJacketCellToYellowJacket && closestEmptyYellowJacketCellToYellowJacket.typeOfCell == 'empty')
            {
                closestEmptyYellowJacketCellToYellowJacket.typeOfCell = 'brood';
                yellowJacket.scene.broods.push( new Broods(
                    yellowJacket.scene,
                    closestEmptyYellowJacketCellToYellowJacket.x,
                    closestEmptyYellowJacketCellToYellowJacket.y,
                    'pupaYellowjacket.png',
                    yellowJacket.username,
                    closestEmptyYellowJacketCellToYellowJacket)
                );
                utility.setDepthOfGroups(yellowJacket.scene);
                yellowJacket.recentlyLaidEgg = true;
                // console.log('yellowjacket laid an egg:', yellowJacket.scene.broods);
                yellowJacket.task = 'kill';
                setTimeout(function()
                {
                    yellowJacket.recentlyLaidEgg = false;
                    // console.log('Yellowjacket no longer recently laid egg.');
                }, 60000);
            } else {
                // console.log('There are no empty cells for yellowjacket to lay an egg in.');
            }

        } catch(e) {
        	console.log('There was an error when a yellowjacket tried to lay an egg: ', e);
        }
    },

    setAttackAnimation(yellowJacket)
    {
        try {
            if (yellowJacket.parent.yellowJacketSpine &&
                yellowJacket.parent.yellowJacketSpine.state.tracks[0].animation.name != 'attack')
            {
                let currentAnimation = yellowJacket.parent.yellowJacketSpine.state.tracks[0].animation.name;
                // console.log('Setting attack animation. Current animation:', currentAnimation);
                yellowJacket.parent.yellowJacketSpine.setAnimation(0, 'attack', false);
                yellowJacket.parent.yellowJacketSpine.addAnimation(0, currentAnimation, true, 0);
            }
        } catch (e) {
            console.log('Error occurred when setting attack animation on yellowjacket: ', error);
        }
    },

    dies(yellowJacket)
    {
        let scene = yellowJacket.scene;

        // Remove yellowJacket sprite and place a corpse sprite.
        let yellowJacketCorpse = yellowJacket.scene.physics.add.sprite(yellowJacket.x, yellowJacket.y, 'sprites', 'deadYellowJacket.png');
        yellowJacketCorpse.angle = Phaser.Math.RND.integerInRange(0,359);
        yellowJacket.scene.tweens.add({
            targets: yellowJacketCorpse,
            alpha: 0,
            duration: yellowJacket.scene.corpseFadeTime,
            ease: 'Sine'
        });

        // Destroy yellowJacket shadow sprite.
        // yellowJacket.yellowJacketShadowSprite.destroy();

        //Destroy Wasp Spine object.
        if (yellowJacket.yellowJacketSpine)
        {
            yellowJacket.yellowJacketSpine.destroy();
        }

        var childrenBroods = yellowJacket.broodCarriedGroup.getChildren();
        for (var i = 0; i < childrenBroods.length; i++)
        {
            try
            {
                childrenBroods[i].destroy();
            } catch(error) {
                console.log('Error while trying to destroy brood carried by wasp.', error);
            }

        }

        yellowJacket.yellowJacketShadowSprite.destroy();
        yellowJacket.scene.yellowJacketsGroup.remove(yellowJacket);
        yellowJacket.destroy();

        challengeLevels.tallyNumberOfYellowjacketsScores(scene);
    },

    update: function (yellowJacket)
    {

        // Only do these things if this wasp originated on this client.
        if (yellowJacket.yellowJacketSprite.target)
        {
            yellowJacket.yellowJacketSprite._rotation = yellowJacket.scene.physics.accelerateToObject( yellowJacket.yellowJacketSprite, yellowJacket.yellowJacketSprite.target, 200, 100, 100 );
        }
        // Adjust position of shadow sprite.
        var offset = 10;
        yellowJacket.yellowJacketShadowSprite.x = yellowJacket.yellowJacketSprite.x + offset;
        yellowJacket.yellowJacketShadowSprite.y = yellowJacket.yellowJacketSprite.y + offset;
        yellowJacket.yellowJacketShadowSprite.angle = yellowJacket.yellowJacketSprite.angle;

        if (yellowJacket.enableSpine)
        {
            // Adjust position of spine object
            this.yellowJacketSpine.setX(yellowJacket.yellowJacketSprite.x);
            this.yellowJacketSpine.setY(yellowJacket.yellowJacketSprite.y);
            this.yellowJacketSpine.setAngle(yellowJacket.yellowJacketSprite.angle);

            if (yellowJacket.yellowJacketSpine.state.tracks[0].animation.name != 'attack')
            {
                if (yellowJacket.yellowJacketSprite.body.speed >= 10)
                {
                    if (yellowJacket.yellowJacketSpine.state.tracks[0].animation.name != 'flying')
                    {
                        // console.log('yellowJacket now flying.');
                        yellowJacket.yellowJacketSpine.setAnimation(0, 'flying', true, 0);
                    }
                } else {
                    if (yellowJacket.yellowJacketSpine.state.tracks[0].animation.name != 'idle')
                    {
                        // console.log('yellowJacket now idle.');
                        yellowJacket.yellowJacketSpine.setAnimation(0, 'idle', true, 0);
                    }
                }
            }

            // Adjust position of carried brood to match mandibles
            // yellowJacket.mandibleBone = this.yellowJacketSpine.findBone('boneMandible1');
            var childrenBroods = yellowJacket.yellowJacketSprite.broodCarriedGroup.getChildren();
            for (var i = 0; i < childrenBroods.length; i++)
            {
                var childrenBroodsTween = yellowJacket.scene.tweens.add({
                    targets: childrenBroods[i],
                    x: yellowJacket.yellowJacketSprite.x,
                    y: yellowJacket.yellowJacketSprite.y,
                    angle: yellowJacket.yellowJacketSprite.angle,
                    duration: yellowJacket.scene.objectUpdateRate,
                    ease: 'Linear',
                });
                // console.log('larva in mouth location', childrenBroods[i].x, childrenBroods[i].y);
            }

        } else {
            // Update the position of all the broods carried by the yellowJacket to its center
            var childrenBroods = yellowJacket.yellowJacketSprite.broodCarriedGroup.getChildren();
            for (var i = 0; i < childrenBroods.length; i++)
            {
                var childrenBroodsTween = yellowJacket.scene.tweens.add({
                    targets: childrenBroods[i],
                    x: yellowJacket.yellowJacketSprite.x,
                    y: yellowJacket.yellowJacketSprite.y,
                    angle: yellowJacket.yellowJacketSprite.angle,
                    duration: yellowJacket.scene.objectUpdateRate,
                    ease: 'Linear',
                });
            }
        }
    },
});

export var VarroaMites = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function VarroaMites (scene, x, y, username, birthOrder)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.username = username;
        this.birthOrder = birthOrder;

        // Add shadow
        this.varroaMiteShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'varroaMite.png');
        this.varroaMiteShadowSprite.tint = 0x3c2040;
        this.varroaMiteShadowSprite.alpha = .1;

        // Add main sprite
        this.varroaMiteSprite = scene.physics.add.sprite(x, y, 'sprites', 'varroaMite.png');
        scene.varroaMitesGroup.add(this.varroaMiteSprite);
        this.varroaMiteSprite.setBounce(1, 1);
        this.varroaMiteSprite.body.stopVelocityOnCollide = false;
        this.varroaMiteSprite.setAlpha(0);
        this.varroaMiteSprite.varroaMiteShadowSprite = this.varroaMiteShadowSprite;
        this.varroaMiteSprite.parent = this;


        this.varroaMiteSprite.setScale(0,0);
        var fadeInTween = scene.tweens.add({
            targets: this.varroaMiteSprite,
            alpha: '1',
            scaleX: '1',
            scaleY:'1',
            duration: 1000,
            ease: 'Sine',
        });

        this.varroaMiteSprite.hitPoints = 100;
        this.varroaMiteSprite.birthOrder = birthOrder;
        this.varroaMiteSprite.ableToReproduce = false;
        let thisVarroaMite = this.varroaMiteSprite;
        setTimeout(function()
        {
            thisVarroaMite.ableToReproduce = true;
        }, 1000);


        this.varroaMiteSprite.offsetWhenCarriedX = Phaser.Math.RND.integerInRange(-20, 20);
        this.varroaMiteSprite.offsetWhenCarriedY = Phaser.Math.RND.integerInRange(-20, 20);

        // Varroa Mite target
        this.varroaMiteSprite.target = utility.closestWorker(this.scene, this.varroaMiteSprite);
        var pickANewTargetEvent = scene.time.addEvent(
        {
            delay: 5000,
            callback: this.pickANewTarget,
            callbackScope: this,
            loop: true
        });

    },

    pickANewTarget()
    {
        this.varroaMiteSprite.target = utility.closestWorker(this.scene, this.varroaMiteSprite);
    },

    reproduces: function (varroaMite, brood)
    {
        var randomVariationX = Phaser.Math.RND.integerInRange(-10, 10);
        var randomVariationY = Phaser.Math.RND.integerInRange(-10, 10);
        varroaMite.scene.varroaMites.push(
            new VarroaMites(
         		  varroaMite.scene,
         		  varroaMite.x + randomVariationX,
         		  varroaMite.y + randomVariationY,
         		  varroaMite.scene.username,
         		  varroaMite.scene.varroaMites.length
         	 )
       );
    },

    dies(varroaMite)
    {
        // Destroy varroaMite and shadow sprite.
        varroaMite.varroaMiteShadowSprite.destroy();
        varroaMite.scene.varroaMitesGroup.remove(varroaMite);
        varroaMite.destroy();
    },

    update: function (varroaMite)
    {

        // Only do these things if this wasp originated on this client.
        if (varroaMite.varroaMiteSprite.target &&
            varroaMite.active)
        {
            varroaMite.varroaMiteSprite._rotation = varroaMite.scene.physics.accelerateToObject( varroaMite.varroaMiteSprite, varroaMite.varroaMiteSprite.target, 5, 15, 15 );
        }
        // Adjust position of shadow sprite.
        var offset = 10;
        varroaMite.varroaMiteShadowSprite.x = varroaMite.varroaMiteSprite.x + offset - 5;
        varroaMite.varroaMiteShadowSprite.y = varroaMite.varroaMiteSprite.y + offset - 5;
        varroaMite.varroaMiteShadowSprite.angle = varroaMite.varroaMiteSprite.angle;

    },
});

export var messageBoxes = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function messageBoxes (scene)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        this.width = 250;
        this.height = 125;

        this.x = scene.minimapToggle.x;
        this.y = (scene.minimapCamera.x + scene.minimapCamera.height) + 30;

        this.active = true;

        // Add box
        this.messageBox = scene.add.graphics({
            fillStyle: { color: 0xf0db87, alpha: .75 }
        });
        this.messageBox.setX(this.x + 22)
                        .setY(this.y + 22)
                        .setAlpha(0)
                        .setScrollFactor(0)
                        .lineStyle(4, 0xf0db87, 1)
                        .strokeRoundedRect(0, 0, this.width, this.height)
                        .fillRoundedRect(0 ,0 , this.width, this.height)
        scene.uiGroup.add(this.messageBox);

        // Notification Icon
        this.notificationIcon = scene.add.sprite(
            this.x,
            this.y,
            'sprites', 'messageBoxIcon.png'
        );
        this.notificationIcon
            .setScrollFactor(0)
            .setAlpha(0);
        this.notificationIcon.displayOriginX = 0;
        this.notificationIcon.displayOriginY = 0;
        scene.uiGroup.add(this.notificationIcon);
        this.notificationIcon.parent = this;
        this.notificationIcon.setInteractive();
        this.notificationIcon.on('pointerdown', function () {
            this.parent.toggleMessageBox(scene);
        })

        // Stepper Icons
        this.nextIcon = scene.add.sprite(
            this.messageBox.x + (this.width - 30),
            this.messageBox.y + (this.height - 25),
            'sprites', 'nextIcon.png'
        );
        this.nextIcon
            .setScrollFactor(0)
            .setAlpha(0);
        this.nextIcon.displayOriginX = 0;
        this.nextIcon.displayOriginY = 0;
        scene.uiGroup.add(this.nextIcon);
        this.nextIcon.parent = this;
        this.nextIcon.setInteractive();
        this.nextIcon.on('pointerdown', function () {
            this.parent.nextSlide(scene);
        });

        this.previousIcon = scene.add.sprite(
            this.nextIcon.x - this.nextIcon.width - 16,
            this.nextIcon.y,
            'sprites', 'previousIcon.png'
        );
        this.previousIcon
            .setScrollFactor(0)
            .setAlpha(0);
        this.previousIcon.displayOriginX = 0;
        this.previousIcon.displayOriginY = 0;
        scene.uiGroup.add(this.previousIcon);
        this.previousIcon.parent = this;
        this.previousIcon.setInteractive();
        this.previousIcon.on('pointerdown', function () {
            this.parent.previousSlide(scene);
        });

        // Text
        this.text = scene.add.text(
            this.messageBox.x + (this.width/2),
            this.messageBox.y + (this.height/2),
            scene.messageText[scene.messageBoxSelected])
            .setScrollFactor(0)
            .setOrigin(.5, .5)
            .setFontFamily('Arial')
            .setFontSize(16)
            .setColor('#3c2040')
            .setAlpha(0)
            .setWordWrapWidth(this.width - 30, false);
        scene.uiGroup.add(this.text);

        // Fade and scale in.
        let hideTutorial = localStorage.getItem('hideTutorial');
        if (!hideTutorial)
        {
            var fadeInTween = scene.tweens.add({
                targets: [
                    this.messageBox,
                    this.notificationIcon,
                    this.text,
                    this.nextIcon,
                    this.previousIcon
                ],
                alpha: '1',
                duration: 1000,
                ease: 'Sine',
            });
            // Hide tutorial by default next time.
            localStorage.setItem('hideTutorial', true);
        } else {
            this.active = false;

            var fadeInTween = scene.tweens.add({
                targets: [
                    this.notificationIcon
                ],
                alpha: '1',
                duration: 1000,
                ease: 'Sine',
            });
        }

        this.moveMessageBox(scene);

        scene.minimapCamera.ignore(scene.uiGroup);

    },

    moveMessageBox(scene) {

        if (scene.messageBoxes[0])
        {
            // Move messageBoxes.
            scene.messageBoxes[0].x = scene.minimapToggle.x;
            scene.messageBoxes[0].y = (scene.minimapCamera.x + scene.minimapCamera.height) + 15;
            scene.messageBoxes[0].messageBox.setX(scene.messageBoxes[0].x + (scene.messageBoxes[0].notificationIcon.width/2));
            scene.messageBoxes[0].messageBox.setY(scene.messageBoxes[0].y + (scene.messageBoxes[0].notificationIcon.height/2));
            scene.messageBoxes[0].notificationIcon.setX(scene.minimapToggle.x);
            scene.messageBoxes[0].notificationIcon.setY(scene.messageBoxes[0].y);
            scene.messageBoxes[0].text.setX(scene.messageBoxes[0].messageBox.x + (scene.messageBoxes[0].width/2) );
            scene.messageBoxes[0].text.setY(scene.messageBoxes[0].messageBox.y + (scene.messageBoxes[0].height/2));
            scene.messageBoxes[0].nextIcon.setX(scene.messageBoxes[0].messageBox.x + (scene.messageBoxes[0].width - 30));
            scene.messageBoxes[0].nextIcon.setY(scene.messageBoxes[0].messageBox.y + (scene.messageBoxes[0].height - 25));
            scene.messageBoxes[0].previousIcon.setX(scene.messageBoxes[0].nextIcon.x - scene.messageBoxes[0].nextIcon.width - 16);
            scene.messageBoxes[0].previousIcon.setY(scene.messageBoxes[0].nextIcon.y);
        }

    },

    toggleMessageBox(scene)
    {

        if (scene.messageBoxes[0].active)
        {
            scene.messageBoxes[0].active = false;

            // Alpha
            scene.messageBoxes[0].nextIcon.setAlpha(0);
            scene.messageBoxes[0].previousIcon.setAlpha(0);
            scene.messageBoxes[0].text.setAlpha(0);
            scene.messageBoxes[0].messageBox.setAlpha(0);
        } else {

            scene.messageBoxes[0].active = true;

            // Alpha
            scene.messageBoxes[0].nextIcon.setAlpha(1);
            scene.messageBoxes[0].previousIcon.setAlpha(1);
            scene.messageBoxes[0].text.setAlpha(1);
            scene.messageBoxes[0].messageBox.setAlpha(1);
        }

    },

    nextSlide(scene)
    {
        if (scene.messageBoxSelected < scene.messageText.length - 1 )
        {
            scene.messageBoxSelected += 1;
            this.text.setText(scene.messageText[scene.messageBoxSelected]);
        }
    },

    previousSlide(scene)
    {
        if (scene.messageBoxSelected > 0)
        {
            scene.messageBoxSelected -= 1;
            this.text.setText(scene.messageText[scene.messageBoxSelected]);
        }
    }

});



// WEBPACK FOOTER //
// ./src/modules/classes.js